//Set class types here
let utilityClasses = [
  {
    name: "Site",
    rules: [
      // Corrective Reading
      {
        name: "Corrective Reading",
        message: "Corrective Reading",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 1,
        script: "5f55e6318cb485584c076499",
        notify: "all",
      },
      //Electric Meter Credit Low
      {
        name: "Electric Meter Credit Low",
        message: "Electric Meter Credit Low",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 1,
        script: "5f1e832082679a052a9d9898",
        notify: "all",
      },
      //Electricmeter Usage Limit
      {
        name: "Electricmeter Usage Limit",
        message: "Electricmeter Usage Limit",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 10,
        script: "5f1e9d6482679a052a9d9a04",
        notify: "all",
      },

      // Watermeter Daily Usage limit
      {
        name: "Watermeter Daily Usage limit",
        message: "Watermeter Daily Usage limit",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 4,
        script: "5ec279c4f917d805b74df657",
        notify: "all",
      },
      // Watermeter leaking
      {
        name: "Watermeter leaking",
        message: "Watermeter leaking",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 10,
        script: "5eafd16fc453ed7f84c9ae0b",
        notify: "all",
      },
      // Level Sensor : Level low
      {
        name: "Level Sensor",
        message: "Level low",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 8,
        script: "60742e44a3a69b1998f9be45",
        notify: "all",
      },
      // Battery low
      {
        name: "Battery low",
        message: "Battery low",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 7,
        script: "60a38840361c0d0e49d5c18b",
        notify: "all",
      },
      // Weak signal
      {
        name: "Weak signal",
        message: "Weak signal",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 7,
        script: "60a3995b361c0d0e49d5c18f",
        notify: "all",
      },
      // Under/Over Volt -- 4
      {
        name: "Over/Under voltage",
        message: "Over/Under voltage",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 7,
        script: "60a3a1a9361c0d0e49d5c192",
        notify: "all",
      },
      // Electricity tamper -- 5
      {
        name: "Electricity meter tamper",
        message: "Electricity meter tamper",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 7,
        script: "60a39f18361c0d0e49d5c191",
        notify: "all",
      },
      // Overflow -- 3
      {
        name: "Geyser overflow",
        message: "Geyser overflow detected",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 7,
        script: "60a3a81a361c0d0e49d5c194",
        notify: "all",
      },
      // Faulty probe -- 2
      {
        name: "Faulty probe",
        message: "Temperature probe faulty",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 7,
        script: "60a3ab3e361c0d0e49d5c196",
        notify: "all",
      },
      // Temp missing -- 8
      {
        name: "Temperature device missing",
        message: "Temperature device missing",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 7,
        script: "608bece4f1eaff27790b5479",
        notify: "all",
      },
      // Meter down  -- 1
      {
        name: "Device missing",
        message: "Device missing",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 7,
        script: "60b73ba1fe9acd467f747ab9",
        notify: "all",
      },

      //Temperature range
      {
        name: "Temperature range",
        message: "Temperature outside of allowed range",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 2,
        script: "600a98189c89b16addb3721f",
        notify: "all",
      },

      //Temperature report
      {
        name: "Temperature report",
        message: "Report current temperature",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 2,
        script: "608bd221f1eaff27790b5406",
        notify: "all",
      },
      //Pool tamper
      {
        name: "Device Tamper",
        message: "Pool Water Meter Tamper",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 8,
        script: "60d19e96882fab602e0ed566",
        notify: "all",
      }, //Pool toggle
      {
        name: "Device Toggle",
        message: "Pool Water Meter Toggle",
        repeatInterval: 1,
        repeatCount: 0,
        priority: 2,
        script: "60d5a2449dc6f40f7ccd5c4b",
        notify: "all",
      },
    ],
    specifics: [
      {
        value: "",
        type: "string",
        meta: null,
        key: "Site Area",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Site ID",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Billing Period",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Report Email",
      },
      {
        value: false,
        type: "string",
        meta: null,
        key: "VAT",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 1 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 2 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 3 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 4 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 5 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 6 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 7 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 8 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 9 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 10 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 1 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 2 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 3 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 4 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 5 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 6 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 7 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 8 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 9 (KL)",
      },
      {
        value: "false",
        type: "string",
        meta: null,
        key: "Fixed Levies",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 1 (ZAR/kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 2 (ZAR/kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 3 (ZAR/kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 4 (ZAR/kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 5 (ZAR/kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 6 (ZAR/kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 7 (ZAR/kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 8 (ZAR/kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 9 (ZAR/kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step Rate 10 (ZAR/kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 1 (kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 2 (kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 3 (kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 4 (kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 5 (kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 6 (kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 7 (kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 8 (kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Step 9 (kWh)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step 1 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step 2 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step 3 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step 4 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step 5 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step 6 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step 7 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step 8 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step 9 (KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step Rate 1 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step Rate 2 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step Rate 3 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step Rate 4 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step Rate 5 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step Rate 6 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step Rate 7 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step Rate 8 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step Rate 9 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sew Step Rate 10 (ZAR/KL)",
      },
      {
        value: "",
        type: "string",
        meta: null,
        key: "Sewerage Percentage",
      },
      {
        value: "true",
        type: "boolean",
        meta: null,
        key: "Is Site",
      },
    ],
  },
];

export enum AccessLevel {
  CREATE = 0x0001,
  EDIT = 0x0002,
  DELETE = 0x0004,
  VIEW_L1 = 0x0008,
  VIEW_L2 = 0x0010,
  VIEW_L3 = 0x0020,
  VIEW_L4 = 0x0040,
  VIEW_L5 = 0x0080,
  EXECUTE = 0x0100,
  EXECUTE_L1 = 0x0200,
}

export enum AccessGroup {
  account = "account",
  dashboard = "dashboard",
  orgunits = "orgunits",
  people = "people",
  groups = "groups",
  send = "send",
  view = "view",
  development = "development",
  releases = "releases",
  reports = "reports",
  support = "support",
  iot = "iot",
}

export interface BuildSettings {
  //#region :In4mer
  creator: string;
  apiKey: string;
  apiRoot: string;
  addLicencing: boolean;
  addLogoOnNewAccount: boolean;
  enableTFA: boolean;
  usersHeader: string;
  groupsHeader: string;
  devicesHeader: string;
  linkedUsers: any;
  activateAccount: boolean;
  manageAppUserAccess: boolean;
  flavourType: string;
  //#endregion

  //#region : Branding + Formatting
  appFlavour: string;
  tabName: string;
  appName: string;
  loginPanelColor: string;
  loginPanelText: string | undefined;
  signInLogo: string;
  brandLogo: string;
  logoSize: string;
  background: string;
  loginWelcome: string;
  bannerTitle: string;
  bannerLogo: string;
  bannerTopText: string;
  fontFamily: string;
  footerCopyRight: string;
  privacy: string | null;
  terms: string | null;
  documents: string | null;
  feedback: string | null;
  support: string | null;
  linkedin: string | null;
  twitter: string | null;
  youtube: string | null;
  instagram: string | null;
  facebook: string | null;
  downloadPrefix: string;
  homeUrl: string;
  userManual: string;
  showAdmin: boolean;
  extendedDeviceSettingsMandatory: boolean;
  showVerifyUsers: boolean;
  showDeviceQuickView: boolean;
  showLoginanimation: boolean;
  //#endregion

  //#region : IoT setup
  classTypes: any;
  models: any;
  device_prefix: string;

  // classTypes ==> [name:string , rules:[]]
  // models ==> [name:string , modelNumber:string , template:string]

  //#endregion

  //#region : layout
  iframeLinks: any;
  showDevTab: boolean;
  devTabAvailable: boolean;
  showIncidentTab: boolean;
  showMapTab: boolean;
  allowChangeAccount: boolean;
  showManageAccounts: boolean;
  showFAQs: boolean;
  showAppSelector: boolean;
  //#endregion

  bucketDetails: any;
}

class FlocheckDevice {
  //   public name: string = "";
  public code: string = "agr.flo";
  public specifics: any[] = [
    {
      value: "",
      type: "string",
      meta: null,
      key: "Meter Number",
    },
    {
      value: "",
      type: "string",
      meta: null,
      key: "Address Line 1",
    },
    {
      value: "",
      type: "string",
      meta: null,
      key: "Client Name",
    },
    {
      value: "",
      type: "string",
      meta: null,
      key: "Client Phone",
    },
    {
      value: "",
      type: "string",
      meta: null,
      key: "Client Email",
    },
    {
      value: "",
      type: "string",
      meta: null,
      key: "Installer Name",
    },
    {
      value: "",
      type: "string",
      meta: null,
      key: "Install Date",
    },
    {
      value: "",
      type: "string",
      meta: null,
      key: "Opening Reading",
    },
    {
      value: "",
      type: "string",
      meta: null,
      key: "Meter Model",
    },
    {
      value: "",
      type: "string",
      meta: null,
      key: "Daily Usage Limit",
    },
    {
      value: 2,
      type: "number",
      meta: null,
      key: "Tick Factor",
    },
    {
      value: "",
      type: "string",
      meta: null,
      key: "Photo 1",
    },
    {
      value: "",
      type: "string",
      meta: null,
      key: "Photo 2",
    },
    {
      value: "",
      type: "string",
      meta: null,
      key: "Photo 3",
    },
    {
      value: "",
      type: "string",
      meta: null,
      key: "Recipients",
    },
    {
      value: {
        contact_name_01: "",
        farm_name: "",
        phone_01: "",
        sg_code: "",
        email_01: "",
        contact_name_02: "",
        phone_02: "",
      },
      type: "any",
      meta: null,
      key: "client_information",
    },
    {
      value: {
        meter_number: "",
        location_name: "",
        modem_number: "",
        pressure_meter: "",
        district: "",
        sub_district: "",
        sub_sub_district: "",
        latitude: 0,
        longitude: 0,
        altitude: 0,
        summer_area: 0,
        winter_area: 0,
        summer_vol: 0,
        winter_vol: 0,
      },
      type: "any",
      meta: null,
      key: "meter_information",
    },
    {
      value: {
        pump_model: "",
        impeller_size: "",
        motor_output: "",
        motor_speed: "",
        vsd_model: "",
      },
      type: "any",
      meta: null,
      key: "pump_information",
    },
    {
      value: {
        max_flowrate: "",
        max_head: "",
        min_flowrate: "",
        min_head: "",
        min_zero_kw: "",
        gmax_flowrate: "",
        gmax_head: "",
        gmin_flowrate: "",
        gmin_head: "",
        optimum_flowrate: "",
        optimum_head: "",
        optimum_efficiency: "",
        optimum_power: "",
      },
      type: "any",
      meta: null,
      key: "pump_characteristics",
    },
    {
      value: {
        wl_redline: "",
        wl_suc_head: "",
        wl_sensor_height: "",
        wl_level: "",
      },
      type: "any",
      meta: null,
      key: "water_level",
    },
  ];

  constructor(private name: string, multipliers: any | null) {
    this.name = name;
    this.code = `agr.flo.${name.toLowerCase().replace(/\s/g, "")}`;
    // console.log(this.code);
    if (multipliers) this.specifics.push(multipliers);
  }

  // name: "Flocheck Pump Meter";
}

//#region : Staging Flavours
export class StgSettingsBlankUtilities implements BuildSettings {
  //In4mer
  public readonly manageAppUserAccess: boolean = true;
  public readonly creator: string = "In4mDash";
  public readonly apiRoot: string = "https://www.in-4mer.com:3005/api/usr";
  // public readonly apiKey: string = "78d8a6e69bc918cee5bc5109caf314f64c07e20bb440819cbc501d365dfc0e2d";
  public readonly apiKey: string =
    "128dcae838c34b6bcee379ab5abf7531aa45fbe7c26389cc3372bb3ed8947930";
  public readonly activateAccount: boolean = true;

  public readonly usersHeader: string = "User";
  public readonly groupsHeader: string = "Site";
  public readonly devicesHeader: string = "Device";
  public readonly linkedUsers: any = [];
  //Branding + Formatting
  public readonly appFlavour: string = "utilities";
  public readonly tabName: string = "Utilities Dashboard";
  public readonly appName: string = "utilities";
  public readonly fontFamily: string = "'Gill Sans', sans-serif;";
  public readonly loginPanelColor: string = "#333333";
  public readonly loginPanelText = "DISRUPTIVE.DIGITAL.INTELLIGENCE.";
  public readonly signInLogo = "assets/img/tools_duo.png";
  public readonly brandLogo = "assets/img/blank.png";
  public readonly logoSize = "180px";
  public readonly background = "assets/img/bg_dark_1.png";
  public readonly loginWelcome =
    "<h4>Welcome to Utilities Dashboard</h4><br>Your one stop utilities <br>management tool";
  public readonly bannerTitle = "Utilities Dashboard";
  public readonly bannerLogo = "assets/img/in4mer_white.png";
  public readonly footerCopyRight = "©2021 In4m";
  public readonly bannerTopText = null;
  public readonly privacy = "";
  public readonly terms = "";
  public readonly documents = "";
  public readonly feedback = "";
  public readonly downloadPrefix = "utilities";
  public readonly homeUrl = "https://www.appsafest.com/dashboard/safest/";
  public readonly flavourType = "utilities";

  public readonly extendedDeviceSettingsMandatory = false;
  public readonly enableTFA = false;

  // Layout
  public readonly iframeLinks = [
    "https://www.in-4mer.com/3rdparty/webviews/utilities/?$itoken&$ctoken&$role",
  ];
  public readonly showDevTab: boolean = false;
  public readonly devTabAvailable: boolean = true;
  public readonly showIncidentTab: boolean = false;
  public readonly showMapTab: boolean = true;
  public readonly allowChangeAccount: boolean = false;
  public readonly showManageAccounts: boolean = true;
  public readonly showAdmin = false;
  public readonly userManual = null;
  public readonly support = null;
  public readonly addLicencing = true;
  public readonly addLogoOnNewAccount = false;
  public readonly linkedin = null;
  public readonly twitter = null;
  public readonly youtube = null;
  public readonly instagram = null;
  public readonly facebook = null;
  public readonly showFAQs = false;
  public readonly showAppSelector = true;
  public readonly showVerifyUsers = true;
  public readonly showDeviceQuickView = false;
  public readonly showLoginanimation = true;

  public readonly bucketDetails = {
    type: "service_account",
    project_id: "ravenhaven-accitrack",
    private_key_id: "980b69e1f720bc1427ee2e4cfb0d64df8311959b",
    private_key:
      "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDJuu3gF8/YMQO1\ng381KdeoFQxYJVyR03+GHdspoD/xKEyfLOdH0rUYQYr2/TwyrdlsE37AlC5hdEu2\nByVpBY+nQ3wjmjdFWj1m1XuqCGgrZHgc7R9oUfJCUJXupflt00OXwfJMrM5oMKJK\nMOXXbrZ7IUmulK6Lx6mWNjlU8tMWrfA4NvzN+l02hKlYAM0+esbcqkg+nrlPibNK\nSg7aLvpV3vvJ+OJLXTgyiNk1hZchhTQuj7I6RijJuvaw/Pyi3LE05cjvkseHgyue\n8Li0kBVG7x9sOTqh5CwIhp+zMovPzUvWgz+HqYSceFefMsgSL969EmluHnDAD4t+\nRjzQo30LAgMBAAECggEADIbAfaFM5TJJ9iv3qq/x9bx020ZapK165jOVZ9TNE6b6\ndwndRK73Us3DGMopwkXcUeM2BDRPWvrTNrbj4k0Xmf3NSBKr6vELDgckmi7SdRtU\ngAtTX3FzNx306XBB+EldkZ9X8d3rJTob4bp+ky2LREMRZbdSzVg1FiBA2B8J74b6\nQEk0fJnrhlGbCAAhAkMcG9jKlncWioBHbRofUm+KhHLDBv1IqJR5klDSitLqr3ym\nDPVbDMSZcngybeoY+10LEZK7DNyxGO3jK4ZiW2HfJC8f9JcKGKGp6X/Ej6thOPU3\nlF1Tc53tu2QGcYt+xiH/c2cHbNFzYYuZJ9QXUWfH1QKBgQDoh9AdJdx5/R462Vn0\nZXy+ZdpFFsy72ivKHCs0CjoLhfDSqubZFA/KkDQb0u4CgM2MCAVuK5qjGusdAlW/\nVRcPNunwUbsejJoSeeN9/cveBp5AZ550Sx31BZuikMDNFXa6DIsZoebtHF9nBqEr\nPSQ3Z66fT4Nhe3toHnN5UfGvrwKBgQDeF0n7cTx74mxKmYDBnD+HARahKWnQ0gI6\nfrOKSaixSjQ1h5owWk1C7vVZqxhRs2lFuc+u5aUvv2D7rSxbcE5tpWxhBkjE91Nn\noHC5ZE/+YTsgxhNK97SZItT3snEvh8PGDzxh2fj8AXMQhFEMzHEN8O25VT+MhBWm\nqnJpkc/jZQKBgC3dtCg7spyBV/glrT+u0QdBUed00tdu9lo8ai0uozpophL30Oca\ntO6wuQaP+ZCW1XR8lI2hnjPz+FJVhpJh91Vx8H0NsgoZk753Om88o3zc81Qi3Dd2\nJaeR/pv3T4BkbnHOTZW1wLYedZb90MaVndIr6l7UMUcGM1ZbQ0234yNTAoGAF9Y0\nEJK0xS8mJFOZaC5W+yx4u09wlgMUTibvKjaBrpWiSOSG/g2TIU34c2lTsOEquVsa\nGVF4i0llJV4O1rmVEVuh6D/+a3WINCUaNCu6EjlpWTkpNPClJ5J/fR5f25QcxRM5\njd8RRCr7qJgrAs6mi7KCMVQe//vlPwAoS4Bk6akCgYBRtG859zgdLlCFOOfQtkLc\nsfZBa8hDxcT5kYBcjIubMa1qT9Og520+q9J/zE5vG+aqStDz6SIwtoUemsohopOx\ntIzZgzZVZMXQhGv1fA4oyfLVbjhgSR8LrJBDE/cHu6DjD6wXP5E7Q2/6sT+5Mnwm\nArABA3/IzJgLb9+/eRzGyQ==\n-----END PRIVATE KEY-----\n",
    client_email: "ravenhaven-accitrack@appspot.gserviceaccount.com",
    client_id: "111620285050654134730",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url:
      "https://www.googleapis.com/robot/v1/metadata/x509/ravenhaven-accitrack%40appspot.gserviceaccount.com",
  };

  //IoT setup
  //Define rules
  public readonly classTypes = utilityClasses;

  public readonly models = [
       //TODO: revisit, spur of the moment madness adding this before vacation (some client will lose their shit if this isn't there)
       {
        name: "ABB Electricity Meter",
        code: "lora.abbelec",
        specifics: [
          {
            value: "",
            type: "string",
            meta: null,
            key: "Meter Number",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Address Line 1",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Client Name",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Client Phone",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Client Email",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Installer Name",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Install Date",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Opening Reading",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Meter Model",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Daily Usage Limit",
          },
          {
            value: 2,
            type: "number",
            meta: null,
            key: "Tick Factor",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Photo 1",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Photo 2",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Photo 3",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Sigfox Reading",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Recipients",
          },
          {
            value: "",
            type: "string",
            meta: null,
            key: "Credit Low",
          },
        ],
      },
    {
      name: "Sigfox Dry Contact Tag",
      code: "tag.dry",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Sigfox Temperature Tag",
      code: "tag.tmp",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Lora Nano Tag",
      code: "lora.nanotag",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Lora Temperature Tag",
      code: "lora.tmp",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "RF Temperature Tag",
      code: "tag.tmo",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Manual Water Meter",
      code: "qrw.man",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Manual Electric Meter",
      code: "qre.man",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Water Meter",
      code: "tag.rhw",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Credit Low",
        },
      ],
    },
    {
      name: "Smart Valve Water Meter (Discontinued) ",
      code: "tag.h2o",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Electricity Meter",
      code: "tag.rhe",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: 100,
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
      ],
    },
    {
      name: "Smart Geyser",
      code: "atu.log",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
      ],
    },
    {
      name: "Optical Electricity Meter",
      code: "tag.opt",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: 100,
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Credit Low Limit",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "installed",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Corrective Photo",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Corrective Reading Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Corrective Meter Reading",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Corrective Sigfox Reading",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: 1000,
          type: "number",
          meta: null,
          key: "Tick factor",
        },
        {
          value: [],
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Prepaid Water Meter",
      code: "qrw.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qrw.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Prepaid Electricity Meter",
      code: "qre.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qre.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Prepaid Gas Meter",
      code: "qrg.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qrg.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Smart Valve Water Meter V2",
      code: "tag.wmd",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Lora WMD",
      code: "lora.wmd",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Level Sensor",
      code: "tag.lvl",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: 10,
          type: "number",
          meta: null,
          key: "low_level_percentage",
        },
        {
          value: 2850,
          type: "number",
          meta: null,
          key: "sensor_height",
        },
        {
          value: 2700,
          type: "number",
          meta: null,
          key: "overflow_height",
        },
      ],
    },
    {
      name: "Watermeter (Romulus)",
      code: "rom.ptw",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Romulus Electricity meter (Pool)",
      code: "rom.pte",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Romulus Electricity meter (RH)",
      code: "rom.rhe",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
  ];

  public readonly flavourOptions = [
    {
      main: true,
      name: "Utilities",
      link: "https://www.in-4mer.com/utilities?$itoken&$ctoken&$role",
    },
    // {
    //     main: false,
    //     name: "Jobcard",
    //     link: "https://www.in-4mer.com/utilities?$itoken&$ctoken&$role"
    // }
  ];
  public readonly device_prefix = "";
}

export class StgSettingsPrecisionUtilities implements BuildSettings {
  //In4mer
  public readonly manageAppUserAccess: boolean = true;
  public readonly creator: string = "In4mDash";
  public readonly apiRoot: string = "https://www.in-4mer.com:3005/api/usr";
  public readonly apiKey: string =
    "128dcae838c34b6bcee379ab5abf7531aa45fbe7c26389cc3372bb3ed8947930";
  public readonly activateAccount: boolean = true;

  public readonly usersHeader: string = "User";
  public readonly groupsHeader: string = "Site";
  public readonly devicesHeader: string = "Device";
  public readonly linkedUsers: any = [
    {
      //Bradley
      personid: "perOY6a1_8X6qwdYoky1H",
      role: "owner",
    },
  ];

  //Branding + Formatting
  public readonly appFlavour: string = "utilities";
  public readonly tabName: string = "Utilities Dashboard";
  public readonly appName: string = "utilities";
  public readonly fontFamily: string = "'Gill Sans', sans-serif;";
  public readonly loginPanelColor: string = "#333333";
  public readonly loginPanelText = undefined;
  public readonly signInLogo = "assets/img/precision1.png";
  public readonly brandLogo = "assets/img/blank.png";
  public readonly logoSize = "180px";
  public readonly background = "assets/img/bg_dark_1.png";
  public readonly loginWelcome =
    "<h4>Welcome to Precision Utilities</h4><br>Your one stop utilities <br>management tool";
  public readonly bannerTitle = "Utilities Dashboard";
  public readonly bannerLogo = "assets/img/in4mer_white.png";
  public readonly footerCopyRight = "©2021 In4m";
  public readonly bannerTopText = null;
  public readonly privacy = "";
  public readonly terms = "";
  public readonly documents = "";
  public readonly feedback = "";
  public readonly downloadPrefix = "utilities";
  public readonly homeUrl = "https://www.appsafest.com/dashboard/safest/";
  public readonly flavourType = "utilities";

  public readonly extendedDeviceSettingsMandatory = false;
  public readonly enableTFA = false;
  public readonly showLoginanimation = false;

  // Layout
  public readonly iframeLinks = [
    "https://www.in-4mer.com/3rdparty/webviews/utilities/?$itoken&$ctoken&$role",
  ];
  public readonly showDevTab: boolean = false;
  public readonly devTabAvailable: boolean = true;
  public readonly showIncidentTab: boolean = false;
  public readonly showMapTab: boolean = true;
  public readonly allowChangeAccount: boolean = false;
  public readonly showManageAccounts: boolean = true;
  public readonly showAdmin = false;
  public readonly userManual = null;
  public readonly support = null;
  public readonly addLicencing = true;
  public readonly addLogoOnNewAccount = false;
  public readonly linkedin = null;
  public readonly twitter = null;
  public readonly youtube = null;
  public readonly instagram = null;
  public readonly facebook = null;
  public readonly showFAQs = false;
  public readonly showAppSelector = false;
  public readonly showVerifyUsers = true;
  public readonly showDeviceQuickView = false;

  public readonly bucketDetails = {
    type: "service_account",
    project_id: "ravenhaven-accitrack",
    private_key_id: "980b69e1f720bc1427ee2e4cfb0d64df8311959b",
    private_key:
      "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDJuu3gF8/YMQO1\ng381KdeoFQxYJVyR03+GHdspoD/xKEyfLOdH0rUYQYr2/TwyrdlsE37AlC5hdEu2\nByVpBY+nQ3wjmjdFWj1m1XuqCGgrZHgc7R9oUfJCUJXupflt00OXwfJMrM5oMKJK\nMOXXbrZ7IUmulK6Lx6mWNjlU8tMWrfA4NvzN+l02hKlYAM0+esbcqkg+nrlPibNK\nSg7aLvpV3vvJ+OJLXTgyiNk1hZchhTQuj7I6RijJuvaw/Pyi3LE05cjvkseHgyue\n8Li0kBVG7x9sOTqh5CwIhp+zMovPzUvWgz+HqYSceFefMsgSL969EmluHnDAD4t+\nRjzQo30LAgMBAAECggEADIbAfaFM5TJJ9iv3qq/x9bx020ZapK165jOVZ9TNE6b6\ndwndRK73Us3DGMopwkXcUeM2BDRPWvrTNrbj4k0Xmf3NSBKr6vELDgckmi7SdRtU\ngAtTX3FzNx306XBB+EldkZ9X8d3rJTob4bp+ky2LREMRZbdSzVg1FiBA2B8J74b6\nQEk0fJnrhlGbCAAhAkMcG9jKlncWioBHbRofUm+KhHLDBv1IqJR5klDSitLqr3ym\nDPVbDMSZcngybeoY+10LEZK7DNyxGO3jK4ZiW2HfJC8f9JcKGKGp6X/Ej6thOPU3\nlF1Tc53tu2QGcYt+xiH/c2cHbNFzYYuZJ9QXUWfH1QKBgQDoh9AdJdx5/R462Vn0\nZXy+ZdpFFsy72ivKHCs0CjoLhfDSqubZFA/KkDQb0u4CgM2MCAVuK5qjGusdAlW/\nVRcPNunwUbsejJoSeeN9/cveBp5AZ550Sx31BZuikMDNFXa6DIsZoebtHF9nBqEr\nPSQ3Z66fT4Nhe3toHnN5UfGvrwKBgQDeF0n7cTx74mxKmYDBnD+HARahKWnQ0gI6\nfrOKSaixSjQ1h5owWk1C7vVZqxhRs2lFuc+u5aUvv2D7rSxbcE5tpWxhBkjE91Nn\noHC5ZE/+YTsgxhNK97SZItT3snEvh8PGDzxh2fj8AXMQhFEMzHEN8O25VT+MhBWm\nqnJpkc/jZQKBgC3dtCg7spyBV/glrT+u0QdBUed00tdu9lo8ai0uozpophL30Oca\ntO6wuQaP+ZCW1XR8lI2hnjPz+FJVhpJh91Vx8H0NsgoZk753Om88o3zc81Qi3Dd2\nJaeR/pv3T4BkbnHOTZW1wLYedZb90MaVndIr6l7UMUcGM1ZbQ0234yNTAoGAF9Y0\nEJK0xS8mJFOZaC5W+yx4u09wlgMUTibvKjaBrpWiSOSG/g2TIU34c2lTsOEquVsa\nGVF4i0llJV4O1rmVEVuh6D/+a3WINCUaNCu6EjlpWTkpNPClJ5J/fR5f25QcxRM5\njd8RRCr7qJgrAs6mi7KCMVQe//vlPwAoS4Bk6akCgYBRtG859zgdLlCFOOfQtkLc\nsfZBa8hDxcT5kYBcjIubMa1qT9Og520+q9J/zE5vG+aqStDz6SIwtoUemsohopOx\ntIzZgzZVZMXQhGv1fA4oyfLVbjhgSR8LrJBDE/cHu6DjD6wXP5E7Q2/6sT+5Mnwm\nArABA3/IzJgLb9+/eRzGyQ==\n-----END PRIVATE KEY-----\n",
    client_email: "ravenhaven-accitrack@appspot.gserviceaccount.com",
    client_id: "111620285050654134730",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url:
      "https://www.googleapis.com/robot/v1/metadata/x509/ravenhaven-accitrack%40appspot.gserviceaccount.com",
  };

  //IoT setup
  //Define rules
  public readonly classTypes = [
    {
      name: "Site",
      rules: [
        {
          name: "Corrective Reading",
          message: "Corrective Reading",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f55e6318cb485584c076499",
          notify: "all",
        },
        {
          name: "Electric Meter Credit Low",
          message: "Electric Meter Credit Low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f1e832082679a052a9d9898",
          notify: "all",
        },
        {
          name: "Electricmeter Usage Limit",
          message: "Electricmeter Usage Limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f1e9d6482679a052a9d9a04",
          notify: "all",
        },
        {
          name: "Geyser Leak Detected",
          message: "Geyser Leak Detected",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5e60fbeeef9d8f483e3c6713",
          notify: "all",
        },
        {
          name: "Watermeter Daily Usage limit",
          message: "Watermeter Daily Usage limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5ec279c4f917d805b74df657",
          notify: "all",
        },
        {
          name: "Watermeter leaking",
          message: "Watermeter leaking",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5eafd16fc453ed7f84c9ae0b",
          notify: "all",
          schedule: [
            {
              tag: "New Timer",
              repeat: "every",
              days: [],
              hourOn: 22,
              minOn: 0,
              hourOff: 3,
              minOff: 0,
            },
          ],
        },
        {
          name: "Level Sensor",
          message: "Level low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "60742e44a3a69b1998f9be45",
          notify: "all",
        },
      ],
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site Area",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site ID",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Billing Period",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Report Email",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "VAT",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (KL)",
        },
        {
          value: "false",
          type: "string",
          meta: null,
          key: "Fixed Levies",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 9 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sewerage Percentage",
        },
        {
          value: "true",
          type: "boolean",
          meta: null,
          key: "Is Site",
        },
      ],
    },
  ];
  public readonly models = [
    {
      name: "Sigfox Dry Contact Tag",
      code: "tag.dry",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Manual Water Meter",
      code: "qrw.man",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Manual Electric Meter",
      code: "qre.man",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Water Meter",
      code: "tag.rhw",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Credit Low",
        },
      ],
    },
    //TODO: revisit, spur of the moment madness adding this before vacation (some client will lose their shit if this isn't there)
    {
      name: "ABB Electricity Meter",
      code: "lora.abbelec",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Credit Low",
        },
      ],
    },
    {
      name: "Smart Valve Water Meter (Discontinued) ",
      code: "tag.h2o",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Electricity Meter",
      code: "tag.rhe",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: 100,
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
      ],
    },
    {
      name: "Smart Geyser",
      code: "atu.log",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
      ],
    },
    {
      name: "Optical Electricity Meter",
      code: "tag.opt",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: 100,
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        ,
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Credit Low Limit",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "installed",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Corrective Photo",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Corrective Reading Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Corrective Meter Reading",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Corrective Sigfox Reading",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: 1000,
          type: "number",
          meta: null,
          key: "Tick factor",
        },
        {
          value: [],
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Prepaid Water Meter",
      code: "qrw.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qrw.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Prepaid Electricity Meter",
      code: "qre.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qre.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Prepaid Gas Meter",
      code: "qrg.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qrg.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Smart Valve Water Meter V2",
      code: "tag.wmd",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Lora WMD",
      code: "lora.wmd",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Level Sensor",
      code: "tag.lvl",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: 10,
          type: "number",
          meta: null,
          key: "low_level_percentage",
        },
        {
          value: 2850,
          type: "number",
          meta: null,
          key: "sensor_height",
        },
        {
          value: 2700,
          type: "number",
          meta: null,
          key: "overflow_height",
        },
      ],
    },
  ];
  public readonly device_prefix = "";

  public readonly flavourOptions = [];
}

export class StgSettingsPoolUtilities implements BuildSettings {
  //In4mer
  public readonly manageAppUserAccess: boolean = false;
  public readonly creator: string = "In4mDash";
  public readonly apiRoot: string = "https://www.in-4mer.com:3005/api/usr";
  // public readonly apiKey: string = "78d8a6e69bc918cee5bc5109caf314f64c07e20bb440819cbc501d365dfc0e2d";
  public readonly apiKey: string =
    "128dcae838c34b6bcee379ab5abf7531aa45fbe7c26389cc3372bb3ed8947930";
  public readonly activateAccount: boolean = true;

  public readonly usersHeader: string = "User";
  public readonly groupsHeader: string = "Site";
  public readonly devicesHeader: string = "Device";
  public readonly linkedUsers: any = [];
  //Branding + Formatting
  public readonly appFlavour: string = "utilities";
  public readonly tabName: string = "Utilities Dashboard";
  public readonly appName: string = "utilities";
  public readonly fontFamily: string = "'Gill Sans', sans-serif;";
  public readonly loginPanelColor: string = "#333333";
  public readonly loginPanelText = "DISRUPTIVE.DIGITAL.INTELLIGENCE.";
  public readonly signInLogo = "assets/img/tools_duo.png";
  public readonly brandLogo = "assets/img/blank.png";
  public readonly logoSize = "180px";
  public readonly background = "assets/img/bg_dark_1.png";
  public readonly loginWelcome =
    "<h4>Welcome to Utilities Dashboard</h4><br>Your one stop utilities <br>management tool";
  public readonly bannerTitle = "Utilities Dashboard";
  public readonly bannerLogo = "assets/img/in4mer_white.png";
  public readonly footerCopyRight = "©2021 In4m";
  public readonly bannerTopText = null;
  public readonly privacy = "";
  public readonly terms = "";
  public readonly documents = "";
  public readonly feedback = "";
  public readonly downloadPrefix = "utilities";
  public readonly homeUrl = "https://www.appsafest.com/dashboard/safest/";
  public readonly flavourType = "utilities";

  public readonly extendedDeviceSettingsMandatory = false;
  public readonly enableTFA = false;

  // Layout
  public readonly iframeLinks = [
    "https://www.in-4mer.com/3rdparty/webviews/utilities/?$itoken&$ctoken&$role",
  ];
  public readonly showDevTab: boolean = false;
  public readonly devTabAvailable: boolean = true;
  public readonly showIncidentTab: boolean = false;
  public readonly showMapTab: boolean = true;
  public readonly allowChangeAccount: boolean = false;
  public readonly showManageAccounts: boolean = true;
  public readonly showAdmin = false;
  public readonly userManual = null;
  public readonly support = null;
  public readonly addLicencing = true;
  public readonly addLogoOnNewAccount = false;
  public readonly linkedin = null;
  public readonly twitter = null;
  public readonly youtube = null;
  public readonly instagram = null;
  public readonly facebook = null;
  public readonly showFAQs = false;
  public readonly showAppSelector = true;
  public readonly showVerifyUsers = true;
  public readonly showDeviceQuickView = false;
  public readonly showLoginanimation = true;

  public readonly bucketDetails = {
    type: "service_account",
    project_id: "ravenhaven-accitrack",
    private_key_id: "980b69e1f720bc1427ee2e4cfb0d64df8311959b",
    private_key:
      "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDJuu3gF8/YMQO1\ng381KdeoFQxYJVyR03+GHdspoD/xKEyfLOdH0rUYQYr2/TwyrdlsE37AlC5hdEu2\nByVpBY+nQ3wjmjdFWj1m1XuqCGgrZHgc7R9oUfJCUJXupflt00OXwfJMrM5oMKJK\nMOXXbrZ7IUmulK6Lx6mWNjlU8tMWrfA4NvzN+l02hKlYAM0+esbcqkg+nrlPibNK\nSg7aLvpV3vvJ+OJLXTgyiNk1hZchhTQuj7I6RijJuvaw/Pyi3LE05cjvkseHgyue\n8Li0kBVG7x9sOTqh5CwIhp+zMovPzUvWgz+HqYSceFefMsgSL969EmluHnDAD4t+\nRjzQo30LAgMBAAECggEADIbAfaFM5TJJ9iv3qq/x9bx020ZapK165jOVZ9TNE6b6\ndwndRK73Us3DGMopwkXcUeM2BDRPWvrTNrbj4k0Xmf3NSBKr6vELDgckmi7SdRtU\ngAtTX3FzNx306XBB+EldkZ9X8d3rJTob4bp+ky2LREMRZbdSzVg1FiBA2B8J74b6\nQEk0fJnrhlGbCAAhAkMcG9jKlncWioBHbRofUm+KhHLDBv1IqJR5klDSitLqr3ym\nDPVbDMSZcngybeoY+10LEZK7DNyxGO3jK4ZiW2HfJC8f9JcKGKGp6X/Ej6thOPU3\nlF1Tc53tu2QGcYt+xiH/c2cHbNFzYYuZJ9QXUWfH1QKBgQDoh9AdJdx5/R462Vn0\nZXy+ZdpFFsy72ivKHCs0CjoLhfDSqubZFA/KkDQb0u4CgM2MCAVuK5qjGusdAlW/\nVRcPNunwUbsejJoSeeN9/cveBp5AZ550Sx31BZuikMDNFXa6DIsZoebtHF9nBqEr\nPSQ3Z66fT4Nhe3toHnN5UfGvrwKBgQDeF0n7cTx74mxKmYDBnD+HARahKWnQ0gI6\nfrOKSaixSjQ1h5owWk1C7vVZqxhRs2lFuc+u5aUvv2D7rSxbcE5tpWxhBkjE91Nn\noHC5ZE/+YTsgxhNK97SZItT3snEvh8PGDzxh2fj8AXMQhFEMzHEN8O25VT+MhBWm\nqnJpkc/jZQKBgC3dtCg7spyBV/glrT+u0QdBUed00tdu9lo8ai0uozpophL30Oca\ntO6wuQaP+ZCW1XR8lI2hnjPz+FJVhpJh91Vx8H0NsgoZk753Om88o3zc81Qi3Dd2\nJaeR/pv3T4BkbnHOTZW1wLYedZb90MaVndIr6l7UMUcGM1ZbQ0234yNTAoGAF9Y0\nEJK0xS8mJFOZaC5W+yx4u09wlgMUTibvKjaBrpWiSOSG/g2TIU34c2lTsOEquVsa\nGVF4i0llJV4O1rmVEVuh6D/+a3WINCUaNCu6EjlpWTkpNPClJ5J/fR5f25QcxRM5\njd8RRCr7qJgrAs6mi7KCMVQe//vlPwAoS4Bk6akCgYBRtG859zgdLlCFOOfQtkLc\nsfZBa8hDxcT5kYBcjIubMa1qT9Og520+q9J/zE5vG+aqStDz6SIwtoUemsohopOx\ntIzZgzZVZMXQhGv1fA4oyfLVbjhgSR8LrJBDE/cHu6DjD6wXP5E7Q2/6sT+5Mnwm\nArABA3/IzJgLb9+/eRzGyQ==\n-----END PRIVATE KEY-----\n",
    client_email: "ravenhaven-accitrack@appspot.gserviceaccount.com",
    client_id: "111620285050654134730",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url:
      "https://www.googleapis.com/robot/v1/metadata/x509/ravenhaven-accitrack%40appspot.gserviceaccount.com",
  };

  //IoT setup
  //Define rules
  public readonly classTypes = [
    {
      name: "Site",
      rules: [
        // Corrective Reading
        {
          name: "Corrective Reading",
          message: "Corrective Reading",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 1,
          script: "5f55e6318cb485584c076499",
          notify: "all",
        },
        //Electric Meter Credit Low
        {
          name: "Electric Meter Credit Low",
          message: "Electric Meter Credit Low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 1,
          script: "5f1e832082679a052a9d9898",
          notify: "all",
        },
        //Electricmeter Usage Limit
        {
          name: "Electricmeter Usage Limit",
          message: "Electricmeter Usage Limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f1e9d6482679a052a9d9a04",
          notify: "all",
        },

        // Watermeter Daily Usage limit
        {
          name: "Watermeter Daily Usage limit",
          message: "Watermeter Daily Usage limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 4,
          script: "5ec279c4f917d805b74df657",
          notify: "all",
        },
        // Watermeter leaking
        {
          name: "Watermeter leaking",
          message: "Watermeter leaking",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5eafd16fc453ed7f84c9ae0b",
          notify: "all",
        },
        // Level Sensor : Level low
        {
          name: "Level Sensor",
          message: "Level low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 8,
          script: "60742e44a3a69b1998f9be45",
          notify: "all",
        },
        // Battery low
        {
          name: "Battery low",
          message: "Battery low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60a38840361c0d0e49d5c18b",
          notify: "all",
        },
        // Weak signal
        {
          name: "Weak signal",
          message: "Weak signal",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60a3995b361c0d0e49d5c18f",
          notify: "all",
        },
        // Under/Over Volt -- 4
        {
          name: "Over/Under voltage",
          message: "Over/Under voltage",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60a3a1a9361c0d0e49d5c192",
          notify: "all",
        },
        // Electricity tamper -- 5
        {
          name: "Electricity meter tamper",
          message: "Electricity meter tamper",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60a39f18361c0d0e49d5c191",
          notify: "all",
        },
        // Overflow -- 3
        {
          name: "Geyser overflow",
          message: "Geyser overflow detected",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60a3a81a361c0d0e49d5c194",
          notify: "all",
        },
        // Faulty probe -- 2
        {
          name: "Faulty probe",
          message: "Temperature probe faulty",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60a3ab3e361c0d0e49d5c196",
          notify: "all",
        },
        // Temp missing -- 8
        {
          name: "Temperature device missing",
          message: "Temperature device missing",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "608bece4f1eaff27790b5479",
          notify: "all",
        },
        // Meter down  -- 1
        {
          name: "Device missing",
          message: "Device missing",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60b73ba1fe9acd467f747ab9",
          notify: "all",
        },

        //Temperature range
        {
          name: "Temperature range",
          message: "Temperature outside of allowed range",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 2,
          script: "600a98189c89b16addb3721f",
          notify: "all",
        },

        //Temperature report
        {
          name: "Temperature report",
          message: "Report current temperature",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 2,
          script: "608bd221f1eaff27790b5406",
          notify: "all",
        },
        //Pool tamper
        {
          name: "Device Tamper",
          message: "Pool Water Meter Tamper",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 2,
          script: "60d19e96882fab602e0ed566",
          notify: "all",
        },
        {
          name: "Device Toggle",
          message: "Pool Water Meter Toggle",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 2,
          script: "60d5a2449dc6f40f7ccd5c4b",
          notify: "all",
        },
      ],
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site Area",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site ID",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Billing Period",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Report Email",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "VAT",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (KL)",
        },
        {
          value: "false",
          type: "string",
          meta: null,
          key: "Fixed Levies",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 9 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sewerage Percentage",
        },
        {
          value: "true",
          type: "boolean",
          meta: null,
          key: "Is Site",
        },
      ],
    },
  ];

  public readonly models = [
    {
      name: "Sigfox Dry Contact Tag",
      code: "tag.dry",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Watermeter",
      code: "rom.ptw",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Electricity meter",
      code: "rom.pte",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
  ];

  public readonly flavourOptions = [
    {
      main: true,
      name: "Utilities",
      link: "https://www.in-4mer.com/utilities?$itoken&$ctoken&$role",
    },
    // {
    //     main: false,
    //     name: "Jobcard",
    //     link: "https://www.in-4mer.com/utilities?$itoken&$ctoken&$role"
    // }
  ];

  public readonly device_prefix = "";
}

export class StgSettingsPrecisionFarming implements BuildSettings {
  //In4mer
  public readonly manageAppUserAccess: boolean = false;
  public readonly creator: string = "In4mDash";
  public readonly apiRoot: string = "https://www.in-4mer.com:3005/api/usr";
  // public readonly apiKey: string = "78d8a6e69bc918cee5bc5109caf314f64c07e20bb440819cbc501d365dfc0e2d";
  public readonly apiKey: string =
    "2ba1434421f7204ba2bd7bae7f7625dd1d5fb1316075c9a2e1d92ef13d953622";
  public readonly activateAccount: boolean = true;

  public readonly usersHeader: string = "User";
  public readonly groupsHeader: string = "Site";
  public readonly devicesHeader: string = "Device";
  public readonly linkedUsers: any = [];
  //Branding + Formatting
  public readonly appFlavour: string = "precisionfarming";
  public readonly tabName: string = "Precision Farming";
  public readonly appName: string = "precisionfarming";
  public readonly fontFamily: string = "'Gill Sans', sans-serif;";
  public readonly loginPanelColor: string = "#333333";
  public readonly loginPanelText = undefined;
  public readonly signInLogo = "assets/img/tractor_duo.png";
  public readonly brandLogo = "assets/img/blank.png";
  public readonly logoSize = "180px";
  public readonly background = "assets/img/bg_dark_1.png";
  public readonly loginWelcome =
    "<h4>Welcome to Precision Farming Dashboard</h4><br>Your one stop agricultural <br>management tool";
  public readonly bannerTitle = "Precision Farming";
  public readonly bannerLogo = "assets/img/in4mer_white.png";
  public readonly footerCopyRight = "©2021 In4m";
  public readonly bannerTopText = null;
  public readonly privacy = "";
  public readonly terms = "";
  public readonly documents = "";
  public readonly feedback = "";
  public readonly downloadPrefix = "precisionfarming";
  public readonly homeUrl = "https://www.appsafest.com/dashboard/safest/";
  public readonly flavourType = "utilities";

  public readonly extendedDeviceSettingsMandatory = false;
  public readonly enableTFA = false;

  // Layout
  public readonly iframeLinks = [
    "https://www.in-4mer.com/3rdparty/webviews/agri/?$itoken&$flavour&$ctoken&$role",
  ];
  public readonly showDevTab: boolean = true;
  public readonly devTabAvailable: boolean = true;
  public readonly showIncidentTab: boolean = false;
  public readonly showMapTab: boolean = true;
  public readonly allowChangeAccount: boolean = false;
  public readonly showManageAccounts: boolean = true;
  public readonly showAdmin = false;
  public readonly userManual = null;
  public readonly support = null;
  public readonly addLicencing = true;
  public readonly addLogoOnNewAccount = false;
  public readonly linkedin = null;
  public readonly twitter = null;
  public readonly youtube = null;
  public readonly instagram = null;
  public readonly facebook = null;
  public readonly showFAQs = false;
  public readonly showAppSelector = true;
  public readonly showVerifyUsers = false;
  public readonly showDeviceQuickView = false;
  public readonly showLoginanimation = true;

  //IoT setup
  public readonly classTypes = [
    {
      name: "Site",
      rules: [
        {
          name: "Corrective Reading",
          message: "Corrective Reading",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f55e6318cb485584c076499",
          notify: "all",
        },
        {
          name: "Electric Meter Credit Low",
          message: "Electric Meter Credit Low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f1e832082679a052a9d9898",
          notify: "all",
        },
        {
          name: "Electricmeter Usage Limit",
          message: "Electricmeter Usage Limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f1e9d6482679a052a9d9a04",
          notify: "all",
        },
        {
          name: "Geyser Leak Detected",
          message: "Geyser Leak Detected",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5e60fbeeef9d8f483e3c6713",
          notify: "all",
        },
        {
          name: "Watermeter Daily Usage limit",
          message: "Watermeter Daily Usage limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5ec279c4f917d805b74df657",
          notify: "all",
        },
        {
          name: "Watermeter leaking",
          message: "Watermeter leaking",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5eafd16fc453ed7f84c9ae0b",
          notify: "all",
        },
        {
          name: "Level Sensor",
          message: "Level low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "60742e44a3a69b1998f9be45",
          notify: "all",
        },
        // {
        //     "name": " ",
        //     "message": " ",
        //     "repeatInterval": 1,
        //     "repeatCount": 0,
        //     "priority": 10,
        //     "script": "5eafd16fc453ed7f84c9ae0b",
        //     "notify": "all"
        // }
      ],
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site Area",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site ID",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Billing Period",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Report Email",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "VAT",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (KL)",
        },
        {
          value: "false",
          type: "string",
          meta: null,
          key: "Fixed Levies",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 9 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sewerage Percentage",
        },
        {
          value: "true",
          type: "boolean",
          meta: null,
          key: "Is Site",
        },
      ],
    },
  ];
  public readonly models = [
    {
      name: "RPS",
      code: "rps.agr",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM4",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM5",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM6",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM7",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM8",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN4",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN5",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN6",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN7",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN8",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config1",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config2",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config3",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config4",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config5",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config6",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config7",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config8",
        },
        {
          value: "",
          type: "any",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Water Meter",
      code: "tag.rhw",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Credit Low",
        },
      ],
    },
    {
      name: "Probe",
      code: "rps.tmp",
      specifics: [],
    },
  ];

  public readonly bucketDetails = {
    type: "service_account",
    project_id: "ravenhaven-accitrack",
    private_key_id: "980b69e1f720bc1427ee2e4cfb0d64df8311959b",
    private_key:
      "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDJuu3gF8/YMQO1\ng381KdeoFQxYJVyR03+GHdspoD/xKEyfLOdH0rUYQYr2/TwyrdlsE37AlC5hdEu2\nByVpBY+nQ3wjmjdFWj1m1XuqCGgrZHgc7R9oUfJCUJXupflt00OXwfJMrM5oMKJK\nMOXXbrZ7IUmulK6Lx6mWNjlU8tMWrfA4NvzN+l02hKlYAM0+esbcqkg+nrlPibNK\nSg7aLvpV3vvJ+OJLXTgyiNk1hZchhTQuj7I6RijJuvaw/Pyi3LE05cjvkseHgyue\n8Li0kBVG7x9sOTqh5CwIhp+zMovPzUvWgz+HqYSceFefMsgSL969EmluHnDAD4t+\nRjzQo30LAgMBAAECggEADIbAfaFM5TJJ9iv3qq/x9bx020ZapK165jOVZ9TNE6b6\ndwndRK73Us3DGMopwkXcUeM2BDRPWvrTNrbj4k0Xmf3NSBKr6vELDgckmi7SdRtU\ngAtTX3FzNx306XBB+EldkZ9X8d3rJTob4bp+ky2LREMRZbdSzVg1FiBA2B8J74b6\nQEk0fJnrhlGbCAAhAkMcG9jKlncWioBHbRofUm+KhHLDBv1IqJR5klDSitLqr3ym\nDPVbDMSZcngybeoY+10LEZK7DNyxGO3jK4ZiW2HfJC8f9JcKGKGp6X/Ej6thOPU3\nlF1Tc53tu2QGcYt+xiH/c2cHbNFzYYuZJ9QXUWfH1QKBgQDoh9AdJdx5/R462Vn0\nZXy+ZdpFFsy72ivKHCs0CjoLhfDSqubZFA/KkDQb0u4CgM2MCAVuK5qjGusdAlW/\nVRcPNunwUbsejJoSeeN9/cveBp5AZ550Sx31BZuikMDNFXa6DIsZoebtHF9nBqEr\nPSQ3Z66fT4Nhe3toHnN5UfGvrwKBgQDeF0n7cTx74mxKmYDBnD+HARahKWnQ0gI6\nfrOKSaixSjQ1h5owWk1C7vVZqxhRs2lFuc+u5aUvv2D7rSxbcE5tpWxhBkjE91Nn\noHC5ZE/+YTsgxhNK97SZItT3snEvh8PGDzxh2fj8AXMQhFEMzHEN8O25VT+MhBWm\nqnJpkc/jZQKBgC3dtCg7spyBV/glrT+u0QdBUed00tdu9lo8ai0uozpophL30Oca\ntO6wuQaP+ZCW1XR8lI2hnjPz+FJVhpJh91Vx8H0NsgoZk753Om88o3zc81Qi3Dd2\nJaeR/pv3T4BkbnHOTZW1wLYedZb90MaVndIr6l7UMUcGM1ZbQ0234yNTAoGAF9Y0\nEJK0xS8mJFOZaC5W+yx4u09wlgMUTibvKjaBrpWiSOSG/g2TIU34c2lTsOEquVsa\nGVF4i0llJV4O1rmVEVuh6D/+a3WINCUaNCu6EjlpWTkpNPClJ5J/fR5f25QcxRM5\njd8RRCr7qJgrAs6mi7KCMVQe//vlPwAoS4Bk6akCgYBRtG859zgdLlCFOOfQtkLc\nsfZBa8hDxcT5kYBcjIubMa1qT9Og520+q9J/zE5vG+aqStDz6SIwtoUemsohopOx\ntIzZgzZVZMXQhGv1fA4oyfLVbjhgSR8LrJBDE/cHu6DjD6wXP5E7Q2/6sT+5Mnwm\nArABA3/IzJgLb9+/eRzGyQ==\n-----END PRIVATE KEY-----\n",
    client_email: "ravenhaven-accitrack@appspot.gserviceaccount.com",
    client_id: "111620285050654134730",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url:
      "https://www.googleapis.com/robot/v1/metadata/x509/ravenhaven-accitrack%40appspot.gserviceaccount.com",
  };

  public readonly flavourOptions = [
    // {
    //     main: true,
    //     name: "Precision Farming",
    //     link: "https://www.in-4mer.com/agri?$itoken&$ctoken&$role"
    // },
    // {
    //     main: false,
    //     name: "QR Farming",
    //     link: "https://www.in-4mer.com/agri?$itoken&$ctoken&$role"
    // }
  ];

  public readonly device_prefix = "";
}

export class StgSettingsFlowcheckUtilities implements BuildSettings {
  //In4mer
  public readonly manageAppUserAccess: boolean = false;
  public readonly creator: string = "Flowcheck";

  public readonly apiRoot: string = "https://www.in-4mer.com:3005/api/usr";
  public readonly apiKey: string =
    "169cb01ae65edc1294f852c82c6d3015d9ae052a49d24c143d1cf53610a01a50";
  public readonly activateAccount: boolean = false;

  public readonly usersHeader: string = "User";
  public readonly groupsHeader: string = "Site";
  public readonly devicesHeader: string = "Device";
  public readonly linkedUsers: any = [
    {
      //Lourens
      personid: "perdQDCtUFqpKkEb4Xz55",
      role: "owner",
    },
  ];

  //Branding + Formatting
  public readonly appFlavour: string = "flowcheck";
  public readonly tabName: string = "Flowcheck Dashboard";
  public readonly appName: string = "flowcheck";
  public readonly fontFamily: string = "'Gill Sans', sans-serif;";
  public readonly loginPanelColor: string = "#333333";
  public readonly loginPanelText = undefined;
  public readonly signInLogo = "assets/img/tractor_duo.png";
  public readonly brandLogo = "assets/img/blank.png";
  public readonly logoSize = "180px";
  public readonly background = "assets/img/bg_dark_1.png";
  public readonly loginWelcome =
    "<h4>Welcome to Flocheck</h4><br>Your one stop agri <br>management tool";
  public readonly bannerTitle = "Flocheck Dashboard";
  public readonly bannerLogo = "assets/img/in4mer_white.png";
  public readonly footerCopyRight = "©2021 In4m";
  public readonly bannerTopText = null;
  public readonly privacy = "";
  public readonly terms = "";
  public readonly documents = "";
  public readonly feedback = "";
  public readonly downloadPrefix = "flocheck";
  public readonly homeUrl = "https://www.in-4mer.com/flavours/flocheck/";
  public readonly flavourType = "utilities";

  public readonly extendedDeviceSettingsMandatory = false;
  public readonly enableTFA = false;
  public readonly showLoginanimation = false;

  // Layout
  public readonly iframeLinks = [
    "https://www.in-4mer.com/3rdparty/webviews/flowcheck/?$itoken&$ctoken&$role&$entity",
  ];
  public readonly showDevTab: boolean = false;
  public readonly devTabAvailable: boolean = false;
  public readonly showIncidentTab: boolean = false;
  public readonly showMapTab: boolean = true;
  public readonly allowChangeAccount: boolean = false;
  public readonly showManageAccounts: boolean = true;
  public readonly showAdmin = false;
  public readonly userManual = null;
  public readonly support = null;
  public readonly addLicencing = true;
  public readonly addLogoOnNewAccount = false;
  public readonly linkedin = null;
  public readonly twitter = null;
  public readonly youtube = null;
  public readonly instagram = null;
  public readonly facebook = null;
  public readonly showFAQs = false;
  public readonly showAppSelector = true;
  public readonly showVerifyUsers = false;
  public readonly showDeviceQuickView = false;
  public readonly flavourOptions = [];

  public readonly bucketDetails = {
    type: "service_account",
    project_id: "ravenhaven-accitrack",
    private_key_id: "980b69e1f720bc1427ee2e4cfb0d64df8311959b",
    private_key:
      "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDJuu3gF8/YMQO1\ng381KdeoFQxYJVyR03+GHdspoD/xKEyfLOdH0rUYQYr2/TwyrdlsE37AlC5hdEu2\nByVpBY+nQ3wjmjdFWj1m1XuqCGgrZHgc7R9oUfJCUJXupflt00OXwfJMrM5oMKJK\nMOXXbrZ7IUmulK6Lx6mWNjlU8tMWrfA4NvzN+l02hKlYAM0+esbcqkg+nrlPibNK\nSg7aLvpV3vvJ+OJLXTgyiNk1hZchhTQuj7I6RijJuvaw/Pyi3LE05cjvkseHgyue\n8Li0kBVG7x9sOTqh5CwIhp+zMovPzUvWgz+HqYSceFefMsgSL969EmluHnDAD4t+\nRjzQo30LAgMBAAECggEADIbAfaFM5TJJ9iv3qq/x9bx020ZapK165jOVZ9TNE6b6\ndwndRK73Us3DGMopwkXcUeM2BDRPWvrTNrbj4k0Xmf3NSBKr6vELDgckmi7SdRtU\ngAtTX3FzNx306XBB+EldkZ9X8d3rJTob4bp+ky2LREMRZbdSzVg1FiBA2B8J74b6\nQEk0fJnrhlGbCAAhAkMcG9jKlncWioBHbRofUm+KhHLDBv1IqJR5klDSitLqr3ym\nDPVbDMSZcngybeoY+10LEZK7DNyxGO3jK4ZiW2HfJC8f9JcKGKGp6X/Ej6thOPU3\nlF1Tc53tu2QGcYt+xiH/c2cHbNFzYYuZJ9QXUWfH1QKBgQDoh9AdJdx5/R462Vn0\nZXy+ZdpFFsy72ivKHCs0CjoLhfDSqubZFA/KkDQb0u4CgM2MCAVuK5qjGusdAlW/\nVRcPNunwUbsejJoSeeN9/cveBp5AZ550Sx31BZuikMDNFXa6DIsZoebtHF9nBqEr\nPSQ3Z66fT4Nhe3toHnN5UfGvrwKBgQDeF0n7cTx74mxKmYDBnD+HARahKWnQ0gI6\nfrOKSaixSjQ1h5owWk1C7vVZqxhRs2lFuc+u5aUvv2D7rSxbcE5tpWxhBkjE91Nn\noHC5ZE/+YTsgxhNK97SZItT3snEvh8PGDzxh2fj8AXMQhFEMzHEN8O25VT+MhBWm\nqnJpkc/jZQKBgC3dtCg7spyBV/glrT+u0QdBUed00tdu9lo8ai0uozpophL30Oca\ntO6wuQaP+ZCW1XR8lI2hnjPz+FJVhpJh91Vx8H0NsgoZk753Om88o3zc81Qi3Dd2\nJaeR/pv3T4BkbnHOTZW1wLYedZb90MaVndIr6l7UMUcGM1ZbQ0234yNTAoGAF9Y0\nEJK0xS8mJFOZaC5W+yx4u09wlgMUTibvKjaBrpWiSOSG/g2TIU34c2lTsOEquVsa\nGVF4i0llJV4O1rmVEVuh6D/+a3WINCUaNCu6EjlpWTkpNPClJ5J/fR5f25QcxRM5\njd8RRCr7qJgrAs6mi7KCMVQe//vlPwAoS4Bk6akCgYBRtG859zgdLlCFOOfQtkLc\nsfZBa8hDxcT5kYBcjIubMa1qT9Og520+q9J/zE5vG+aqStDz6SIwtoUemsohopOx\ntIzZgzZVZMXQhGv1fA4oyfLVbjhgSR8LrJBDE/cHu6DjD6wXP5E7Q2/6sT+5Mnwm\nArABA3/IzJgLb9+/eRzGyQ==\n-----END PRIVATE KEY-----\n",
    client_email: "ravenhaven-accitrack@appspot.gserviceaccount.com",
    client_id: "111620285050654134730",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url:
      "https://www.googleapis.com/robot/v1/metadata/x509/ravenhaven-accitrack%40appspot.gserviceaccount.com",
  };

  //IoT setup
  //Define rules
  public readonly classTypes = [
    {
      name: "Site",
      rules: [],
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site Area",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site ID",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Billing Period",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Report Email",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "VAT",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (KL)",
        },
        {
          value: "false",
          type: "string",
          meta: null,
          key: "Fixed Levies",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 9 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sewerage Percentage",
        },
        {
          value: "true",
          type: "boolean",
          meta: null,
          key: "Is Site",
        },
      ],
    },
  ];
  public readonly models = [
    // {
    //   name: "Flocheck Pump Meter",
    //   code: "agr.flo",
    //   specifics: [
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Meter Number",
    //     },
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Address Line 1",
    //     },
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Client Name",
    //     },
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Client Phone",
    //     },
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Client Email",
    //     },
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Installer Name",
    //     },
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Install Date",
    //     },
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Opening Reading",
    //     },
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Meter Model",
    //     },
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Daily Usage Limit",
    //     },
    //     {
    //       value: 2,
    //       type: "number",
    //       meta: null,
    //       key: "Tick Factor",
    //     },
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Photo 1",
    //     },
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Photo 2",
    //     },
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Photo 3",
    //     },
    //     {
    //       value: "",
    //       type: "string",
    //       meta: null,
    //       key: "Recipients",
    //     },
    //   ],
    // },
    new FlocheckDevice("Elster", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: {
        Calibration1: 1,
        Calibration2: 1,
        AccFlow: 1,
        InstFlow: 1,
        FlowRegion1: 1,
        FlowRegion2: 1,
        FlowRegion3: 1,
        FlowRegion4: 1,
        PumpTime: 0.000277778,
        ImportWh: 0.001,
        ExportWh: 0.001,
        Q1varh: 0.001,
        Q2varh: 0.001,
        Q3varh: 0.001,
        Q4varh: 0.001,
        VAh: 0.001,
        Va: 1,
        Vb: 1,
        Vc: 1,
        IaMag: 1,
        IbMag: 1,
        IcMag: 1,
        Ptot: 0.001,
        Pa: 0.001,
        Pb: 0.001,
        Pc: 0.001,
        Qtot: 0.001,
        Qa: 0.001,
        Qb: 0.001,
        Qc: 0.001,
        Stot: 0.001,
        Sa: 0.001,
        Sb: 0.001,
        Sc: 0.001,
        PFtot: 1,
        PFa: 1,
        PFb: 1,
        PFc: 1,
        Frequency: 1,
        IaAng: 1,
        IbAng: 1,
        IcAng: 1,
        VaAng: 1,
        VbAng: 1,
        VcAng: 1,
        TOU1: 1,
        TOU2: 1,
        TOU3: 1,
        TOU4: 1,
        SerialNumber: 1,
        MeterTime: 1,
        Uptime: 1,
        Version: 1,
      },
    }),
    new FlocheckDevice("Itron", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: {
        AccFlow: 1,
        InstFlow: 1,
        FlowRegion1: 1,
        FlowRegion2: 1,
        FlowRegion3: 1,
        FlowRegion4: 1,
        ImportWh: 1,
        ExportWh: 1,
        VAh: 1,
        Va: 1,
        Vb: 1,
        Vc: 1,
        IaMag: 1,
        IbMag: 1,
        IcMag: 1,
        Ptot: 1,
        Qtot: 1,
        Stot: 1,
        PFtot: 1,
        Frequency: 1,
        SerialNumber: 1,
        Version: 1,
        VaMax: 1,
        VbMax: 1,
        VcMax: 1,
        VaMin: 1,
        VbMin: 1,
        VcMin: 1,
        Importvarh: 1,
        Exportvarh: 1,
        MD: 1,
        Region1Wh: 1,
        Region2Wh: 1,
        Region3Wh: 1,
        Region4Wh: 1,
        Maxflow: 1,
        PowerOnCount: 1,
        WatchdogCount: 1,
        Pabs: 1,
      },
    }),
    new FlocheckDevice("VSD", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: {
        AccFlow: 1,
        InstFlow: 1,
        PumpTime: 0.000277778,
        Frequency: 1,
        SerialNumber: 1,
        kWh: 1,
        kW: 1,
        LimitSlope: 1,
        Coef0: 1,
        Coef1: 1,
        Coef2: 1,
        Coef3: 1,
        Online: 1,
      },
    }),
    new FlocheckDevice("SAFMag", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: {
        AccFlow: 1,
        InstFlow: 1,
      },
    }),
    new FlocheckDevice("SAFMag 2", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: {
        AccFlow: 1,
        InstFlow: 1,
      },
    }),
    new FlocheckDevice("SAFsonic", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: {
        AccFlow: 1,
        InstFlow: 1,
      },
    }),
    new FlocheckDevice("Pulselog", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: { Pulse1: 1, Pulse2: 1, Pulse3: 1, Pulse4: 1 },
    }),
    new FlocheckDevice("Siemens", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: {
        AccFlow: 1,
        InstFlow: 1,
      },
    }),
    new FlocheckDevice("Mag6000", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: {
        AccFlow: 1,
        InstFlow: 1,
        AccFlow2: 1,
      },
    }),
    new FlocheckDevice("Rievech PLC", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: {
        "Pump Head": 0.1019977,
        "Suction Head": 0.1019977,
        "Water Level": 0.001,
        EC: 1,
        AF5: 1,
        AF6: 1,
        AF7: 1,
        AF8: 1,
        AF9: 1,
        AF10: 1,
        AF11: 1,
        AF12: 1,
        AF13: 1,
        AF14: 1,
        AF15: 1,
        AF16: 1,
        AF17: 1,
        AF18: 1,
        AF19: 1,
        AF20: 1,
        AF21: 1,
        AF22: 1,
        AF23: 1,
        AF24: 1,
        AF25: 1,
        AF26: 1,
        AF27: 1,
        AF28: 1,
        AF29: 1,
        AF30: 1,
        AF31: 1,
        AF32: 1,
      },
    }),
    new FlocheckDevice("ME15.11", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: {
        Pulse1: 1,
        Pulse2: 1,
        Pulse3: 1,
        Pulse4: 1,
      },
    }),
    new FlocheckDevice("BHK2000B", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: {
        AccFlow: 1,
        InstFlow: 1,
        NetAccumulator: 1,
        NegativeAccumulator: 1,
      },
    }),
    new FlocheckDevice("WP9038ADAM", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: {
        Analog1: 1,
        Analog2: 1,
        Analog3: 1,
        Analog4: 1,
        Analog5: 1,
        Analog6: 1,
        DigitalIn1: 1,
        DigitalIn2: 1,
        DigitalIn3: 1,
        DigitalIn4: 1,
        DigitalOut1: 1,
        DigitalOut2: 1,
        DigitalOut3: 1,
        DigitalOut4: 1,
        User1: 1,
      },
    }),
    new FlocheckDevice("Gentick EC", {
      type: "string",
      meta: null,
      key: "register_multipliers",
      value: {
        SerialNumber: 1,
        EC: 100,
        Temperature: 1,
      },
    }),
  ];
  public readonly device_prefix = "flo";
}

export class StgSettingsThermologix implements BuildSettings {
  //In4mer
  public readonly manageAppUserAccess: boolean = false;
  public readonly creator: string = "In4mDash";
  public readonly apiRoot: string = "https://www.in-4mer.com:3005/api/usr";
  // PRODUCTION public readonly apiKey: string = "329bfb5cf915a6e22aa64b2217b9febedcd4397146b4aa5dddb001e6aaafbb14";
  public readonly apiKey: string =
    "128dcae838c34b6bcee379ab5abf7531aa45fbe7c26389cc3372bb3ed8947930";
  public readonly activateAccount: boolean = true;

  public readonly usersHeader: string = "User";
  public readonly groupsHeader: string = "Site";
  public readonly devicesHeader: string = "Device";
  public readonly linkedUsers: any = [];
  //Branding + Formatting
  public readonly appFlavour: string = "utilities";
  public readonly tabName: string = "Thermologix Dashboard";
  public readonly appName: string = "utilities";
  public readonly fontFamily: string = "'Gill Sans', sans-serif;";
  public readonly loginPanelColor: string = "#333333";
  public readonly loginPanelText = undefined;
  public readonly signInLogo = "assets/img/thermologix.png";
  public readonly brandLogo = "assets/img/thermologix_brand.png";
  public readonly logoSize = "180px";
  public readonly background = "assets/img/bg_dark_1.png";
  public readonly loginWelcome =
    "<h4>Welcome to Thermologix Dashboard</h4><br>Your one stop thermal <br>management tool";
  public readonly bannerTitle = "Thermologix Dashboard";
  public readonly bannerLogo = "assets/img/in4mer_white.png";
  public readonly footerCopyRight = "©2021 In4m";
  public readonly bannerTopText = null;
  public readonly privacy = "";
  public readonly terms = "";
  public readonly documents = "";
  public readonly feedback = "";
  public readonly downloadPrefix = "utilities";
  public readonly homeUrl = "https://www.appsafest.com/dashboard/safest/";
  public readonly flavourType = "thermologix";

  public readonly extendedDeviceSettingsMandatory = false;
  public readonly enableTFA = false;

  // Layout
  public readonly iframeLinks = [
    "https://www.in-4mer.com/3rdparty/webviews/utilities/?$itoken&$ctoken&$role&$ftp",
  ];
  public readonly showDevTab: boolean = false;
  public readonly devTabAvailable: boolean = true;

  public readonly showIncidentTab: boolean = false;
  public readonly showMapTab: boolean = true;
  public readonly allowChangeAccount: boolean = false;
  public readonly showManageAccounts: boolean = true;
  public readonly showAdmin = false;
  public readonly userManual = null;
  public readonly support = null;
  public readonly addLicencing = true;
  public readonly addLogoOnNewAccount = false;
  public readonly linkedin = null;
  public readonly twitter = null;
  public readonly youtube = null;
  public readonly instagram = null;
  public readonly facebook = null;
  public readonly showFAQs = false;
  public readonly showAppSelector = true;
  public readonly showVerifyUsers = true;
  public readonly showDeviceQuickView = false;
  public readonly showLoginanimation = false;

  public readonly bucketDetails = {
    type: "service_account",
    project_id: "ravenhaven-accitrack",
    private_key_id: "980b69e1f720bc1427ee2e4cfb0d64df8311959b",
    private_key:
      "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDJuu3gF8/YMQO1\ng381KdeoFQxYJVyR03+GHdspoD/xKEyfLOdH0rUYQYr2/TwyrdlsE37AlC5hdEu2\nByVpBY+nQ3wjmjdFWj1m1XuqCGgrZHgc7R9oUfJCUJXupflt00OXwfJMrM5oMKJK\nMOXXbrZ7IUmulK6Lx6mWNjlU8tMWrfA4NvzN+l02hKlYAM0+esbcqkg+nrlPibNK\nSg7aLvpV3vvJ+OJLXTgyiNk1hZchhTQuj7I6RijJuvaw/Pyi3LE05cjvkseHgyue\n8Li0kBVG7x9sOTqh5CwIhp+zMovPzUvWgz+HqYSceFefMsgSL969EmluHnDAD4t+\nRjzQo30LAgMBAAECggEADIbAfaFM5TJJ9iv3qq/x9bx020ZapK165jOVZ9TNE6b6\ndwndRK73Us3DGMopwkXcUeM2BDRPWvrTNrbj4k0Xmf3NSBKr6vELDgckmi7SdRtU\ngAtTX3FzNx306XBB+EldkZ9X8d3rJTob4bp+ky2LREMRZbdSzVg1FiBA2B8J74b6\nQEk0fJnrhlGbCAAhAkMcG9jKlncWioBHbRofUm+KhHLDBv1IqJR5klDSitLqr3ym\nDPVbDMSZcngybeoY+10LEZK7DNyxGO3jK4ZiW2HfJC8f9JcKGKGp6X/Ej6thOPU3\nlF1Tc53tu2QGcYt+xiH/c2cHbNFzYYuZJ9QXUWfH1QKBgQDoh9AdJdx5/R462Vn0\nZXy+ZdpFFsy72ivKHCs0CjoLhfDSqubZFA/KkDQb0u4CgM2MCAVuK5qjGusdAlW/\nVRcPNunwUbsejJoSeeN9/cveBp5AZ550Sx31BZuikMDNFXa6DIsZoebtHF9nBqEr\nPSQ3Z66fT4Nhe3toHnN5UfGvrwKBgQDeF0n7cTx74mxKmYDBnD+HARahKWnQ0gI6\nfrOKSaixSjQ1h5owWk1C7vVZqxhRs2lFuc+u5aUvv2D7rSxbcE5tpWxhBkjE91Nn\noHC5ZE/+YTsgxhNK97SZItT3snEvh8PGDzxh2fj8AXMQhFEMzHEN8O25VT+MhBWm\nqnJpkc/jZQKBgC3dtCg7spyBV/glrT+u0QdBUed00tdu9lo8ai0uozpophL30Oca\ntO6wuQaP+ZCW1XR8lI2hnjPz+FJVhpJh91Vx8H0NsgoZk753Om88o3zc81Qi3Dd2\nJaeR/pv3T4BkbnHOTZW1wLYedZb90MaVndIr6l7UMUcGM1ZbQ0234yNTAoGAF9Y0\nEJK0xS8mJFOZaC5W+yx4u09wlgMUTibvKjaBrpWiSOSG/g2TIU34c2lTsOEquVsa\nGVF4i0llJV4O1rmVEVuh6D/+a3WINCUaNCu6EjlpWTkpNPClJ5J/fR5f25QcxRM5\njd8RRCr7qJgrAs6mi7KCMVQe//vlPwAoS4Bk6akCgYBRtG859zgdLlCFOOfQtkLc\nsfZBa8hDxcT5kYBcjIubMa1qT9Og520+q9J/zE5vG+aqStDz6SIwtoUemsohopOx\ntIzZgzZVZMXQhGv1fA4oyfLVbjhgSR8LrJBDE/cHu6DjD6wXP5E7Q2/6sT+5Mnwm\nArABA3/IzJgLb9+/eRzGyQ==\n-----END PRIVATE KEY-----\n",
    client_email: "ravenhaven-accitrack@appspot.gserviceaccount.com",
    client_id: "111620285050654134730",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url:
      "https://www.googleapis.com/robot/v1/metadata/x509/ravenhaven-accitrack%40appspot.gserviceaccount.com",
  };

  //IoT setup
  //Define rules
  // public readonly classTypes = [
  //   {
  //     name: "Site",
  //     rules: [
  //       {
  //         name: "Corrective Reading",
  //         message: "Corrective Reading",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "5f55e6318cb485584c076499",
  //         notify: "all",
  //       },
  //       {
  //         name: "Electric Meter Credit Low",
  //         message: "Electric Meter Credit Low",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "5f1e832082679a052a9d9898",
  //         notify: "all",
  //       },
  //       {
  //         name: "Electricmeter Usage Limit",
  //         message: "Electricmeter Usage Limit",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "5f1e9d6482679a052a9d9a04",
  //         notify: "all",
  //       },
  //       {
  //         name: "Geyser Leak Detected",
  //         message: "Geyser Leak Detected",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "5e60fbeeef9d8f483e3c6713",
  //         notify: "all",
  //       },
  //       {
  //         name: "Watermeter Daily Usage limit",
  //         message: "Watermeter Daily Usage limit",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "5ec279c4f917d805b74df657",
  //         notify: "all",
  //       },
  //       {
  //         name: "Watermeter leaking",
  //         message: "Watermeter leaking",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "5eafd16fc453ed7f84c9ae0b",
  //         notify: "all",
  //       },
  //       {
  //         name: "Level Sensor",
  //         message: "Level low",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "60742e44a3a69b1998f9be45",
  //         notify: "all",
  //       },
  //       // {
  //       //     "name": " ",
  //       //     "message": " ",
  //       //     "repeatInterval": 1,
  //       //     "repeatCount": 0,
  //       //     "priority": 10,
  //       //     "script": "5eafd16fc453ed7f84c9ae0b",
  //       //     "notify": "all"
  //       // }
  //     ],
  //     specifics: [
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Site Area",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Site ID",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Billing Period",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Report Email",
  //       },
  //       {
  //         value: false,
  //         type: "string",
  //         meta: null,
  //         key: "VAT",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 1 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 2 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 3 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 4 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 5 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 6 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 7 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 8 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 9 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 10 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 1 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 2 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 3 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 4 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 5 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 6 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 7 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 8 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 9 (KL)",
  //       },
  //       {
  //         value: "false",
  //         type: "string",
  //         meta: null,
  //         key: "Fixed Levies",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 1 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 2 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 3 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 4 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 5 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 6 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 7 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 8 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 9 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 10 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 1 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 2 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 3 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 4 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 5 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 6 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 7 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 8 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 9 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 1 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 2 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 3 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 4 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 5 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 6 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 7 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 8 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 9 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 1 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 2 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 3 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 4 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 5 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 6 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 7 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 8 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 9 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 10 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sewerage Percentage",
  //       },
  //       {
  //         value: "true",
  //         type: "boolean",
  //         meta: null,
  //         key: "Is Site",
  //       },
  //     ],
  //   },
  // ];

  public readonly classTypes = utilityClasses;
  public readonly models = [
    {
      name: "Sigfox Dry Contact Tag",
      code: "tag.dry",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Sigfox Temperature Tag",
      code: "tag.tmp",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Lora Nano Tag",
      code: "lora.nanotag",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Lora Temperature Tag",
      code: "lora.tmp",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "RF Temperature Tag",
      code: "tag.tmo",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Manual Water Meter",
      code: "qrw.man",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Manual Electric Meter",
      code: "qre.man",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Water Meter",
      code: "tag.rhw",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Credit Low",
        },
      ],
    },
    {
      name: "Smart Valve Water Meter (Discontinued) ",
      code: "tag.h2o",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Electricity Meter",
      code: "tag.rhe",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: 100,
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
      ],
    },
    {
      name: "Smart Geyser",
      code: "atu.log",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
      ],
    },
    {
      name: "Optical Electricity Meter",
      code: "tag.opt",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: 100,
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Credit Low Limit",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "installed",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Corrective Photo",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Corrective Reading Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Corrective Meter Reading",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Corrective Sigfox Reading",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: 1000,
          type: "number",
          meta: null,
          key: "Tick factor",
        },
        {
          value: [],
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Prepaid Water Meter",
      code: "qrw.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qrw.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Prepaid Electricity Meter",
      code: "qre.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qre.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Prepaid Gas Meter",
      code: "qrg.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qrg.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Smart Valve Water Meter V2",
      code: "tag.wmd",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Lora WMD",
      code: "lora.wmd",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
  ];

  public readonly flavourOptions = [
    {
      main: true,
      name: "Utilities",
      link: "https://www.in-4mer.com/utilities?$itoken&$ctoken&$role",
    },
    // {
    //     main: false,
    //     name: "Jobcard",
    //     link: "https://www.in-4mer.com/utilities?$itoken&$ctoken&$role"
    // }
  ];
  public readonly device_prefix = "";
}

//#endregion

//#region : Production Flavours

export class ProdSettingsBlankUtilities implements BuildSettings {
  //In4mer
  public readonly manageAppUserAccess: boolean = true;
  public readonly creator: string = "In4mDash";
  public readonly apiRoot: string = "https://api.in4mgroup.com:3005/api/usr";
  // public readonly apiKey: string = "78d8a6e69bc918cee5bc5109caf314f64c07e20bb440819cbc501d365dfc0e2d";
  public readonly apiKey: string =
    "a49c054837326e06a0adb1cd46747afa857080c2a3ca3adc7d3d00213c6bce7f";
  public readonly activateAccount: boolean = true;

  public readonly usersHeader: string = "User";
  public readonly groupsHeader: string = "Site";
  public readonly devicesHeader: string = "Device";
  public readonly linkedUsers: any = [];
  //Branding + Formatting
  public readonly appFlavour: string = "utilities";
  public readonly tabName: string = "Utilities Dashboard";
  public readonly appName: string = "utilities";
  public readonly fontFamily: string = "'Gill Sans', sans-serif;";
  public readonly loginPanelColor: string = "#333333";
  public readonly loginPanelText = undefined;
  public readonly signInLogo = "assets/img/tools_duo.png";
  public readonly brandLogo = "assets/img/blank.png";
  public readonly logoSize = "180px";
  public readonly background = "assets/img/bg_dark_1.png";
  public readonly loginWelcome =
    "<h4>Welcome to Utilities Dashboard</h4><br>Your one stop utilities <br>management tool";
  public readonly bannerTitle = "Utilities Dashboard";
  public readonly bannerLogo = "assets/img/in4mer_white.png";
  public readonly footerCopyRight = "©2021 In4m";
  public readonly bannerTopText = null;
  public readonly privacy = "";
  public readonly terms = "";
  public readonly documents = "";
  public readonly feedback = "";
  public readonly downloadPrefix = "utilities";
  public readonly homeUrl = "https://www.appsafest.com/dashboard/safest/";
  public readonly flavourType = "utilities";

  public readonly extendedDeviceSettingsMandatory = false;
  public readonly enableTFA = false;
  public readonly showLoginanimation = true;

  // Layout
  public readonly iframeLinks = [
    "https://www.in4mgroup.com/frames/utilities/?$itoken&$ctoken&$role",
  ];
  public readonly showDevTab: boolean = true;
  public readonly devTabAvailable: boolean = true;

  public readonly showIncidentTab: boolean = false;
  public readonly showMapTab: boolean = true;
  public readonly allowChangeAccount: boolean = false;
  public readonly showManageAccounts: boolean = true;
  public readonly showAdmin = false;
  public readonly userManual = null;
  public readonly support = null;
  public readonly addLicencing = true;
  public readonly addLogoOnNewAccount = false;
  public readonly linkedin = null;
  public readonly twitter = null;
  public readonly youtube = null;
  public readonly instagram = null;
  public readonly facebook = null;
  public readonly showFAQs = false;
  public readonly showAppSelector = true;
  public readonly showVerifyUsers = true;
  public readonly showDeviceQuickView = false;

  public readonly bucketDetails = {
    type: "service_account",
    project_id: "ravenhaven-accitrack",
    private_key_id: "980b69e1f720bc1427ee2e4cfb0d64df8311959b",
    private_key:
      "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDJuu3gF8/YMQO1\ng381KdeoFQxYJVyR03+GHdspoD/xKEyfLOdH0rUYQYr2/TwyrdlsE37AlC5hdEu2\nByVpBY+nQ3wjmjdFWj1m1XuqCGgrZHgc7R9oUfJCUJXupflt00OXwfJMrM5oMKJK\nMOXXbrZ7IUmulK6Lx6mWNjlU8tMWrfA4NvzN+l02hKlYAM0+esbcqkg+nrlPibNK\nSg7aLvpV3vvJ+OJLXTgyiNk1hZchhTQuj7I6RijJuvaw/Pyi3LE05cjvkseHgyue\n8Li0kBVG7x9sOTqh5CwIhp+zMovPzUvWgz+HqYSceFefMsgSL969EmluHnDAD4t+\nRjzQo30LAgMBAAECggEADIbAfaFM5TJJ9iv3qq/x9bx020ZapK165jOVZ9TNE6b6\ndwndRK73Us3DGMopwkXcUeM2BDRPWvrTNrbj4k0Xmf3NSBKr6vELDgckmi7SdRtU\ngAtTX3FzNx306XBB+EldkZ9X8d3rJTob4bp+ky2LREMRZbdSzVg1FiBA2B8J74b6\nQEk0fJnrhlGbCAAhAkMcG9jKlncWioBHbRofUm+KhHLDBv1IqJR5klDSitLqr3ym\nDPVbDMSZcngybeoY+10LEZK7DNyxGO3jK4ZiW2HfJC8f9JcKGKGp6X/Ej6thOPU3\nlF1Tc53tu2QGcYt+xiH/c2cHbNFzYYuZJ9QXUWfH1QKBgQDoh9AdJdx5/R462Vn0\nZXy+ZdpFFsy72ivKHCs0CjoLhfDSqubZFA/KkDQb0u4CgM2MCAVuK5qjGusdAlW/\nVRcPNunwUbsejJoSeeN9/cveBp5AZ550Sx31BZuikMDNFXa6DIsZoebtHF9nBqEr\nPSQ3Z66fT4Nhe3toHnN5UfGvrwKBgQDeF0n7cTx74mxKmYDBnD+HARahKWnQ0gI6\nfrOKSaixSjQ1h5owWk1C7vVZqxhRs2lFuc+u5aUvv2D7rSxbcE5tpWxhBkjE91Nn\noHC5ZE/+YTsgxhNK97SZItT3snEvh8PGDzxh2fj8AXMQhFEMzHEN8O25VT+MhBWm\nqnJpkc/jZQKBgC3dtCg7spyBV/glrT+u0QdBUed00tdu9lo8ai0uozpophL30Oca\ntO6wuQaP+ZCW1XR8lI2hnjPz+FJVhpJh91Vx8H0NsgoZk753Om88o3zc81Qi3Dd2\nJaeR/pv3T4BkbnHOTZW1wLYedZb90MaVndIr6l7UMUcGM1ZbQ0234yNTAoGAF9Y0\nEJK0xS8mJFOZaC5W+yx4u09wlgMUTibvKjaBrpWiSOSG/g2TIU34c2lTsOEquVsa\nGVF4i0llJV4O1rmVEVuh6D/+a3WINCUaNCu6EjlpWTkpNPClJ5J/fR5f25QcxRM5\njd8RRCr7qJgrAs6mi7KCMVQe//vlPwAoS4Bk6akCgYBRtG859zgdLlCFOOfQtkLc\nsfZBa8hDxcT5kYBcjIubMa1qT9Og520+q9J/zE5vG+aqStDz6SIwtoUemsohopOx\ntIzZgzZVZMXQhGv1fA4oyfLVbjhgSR8LrJBDE/cHu6DjD6wXP5E7Q2/6sT+5Mnwm\nArABA3/IzJgLb9+/eRzGyQ==\n-----END PRIVATE KEY-----\n",
    client_email: "ravenhaven-accitrack@appspot.gserviceaccount.com",
    client_id: "111620285050654134730",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url:
      "https://www.googleapis.com/robot/v1/metadata/x509/ravenhaven-accitrack%40appspot.gserviceaccount.com",
  };

  //IoT setup
  //Define rules
  public readonly classTypes = [
    {
      name: "Site",
      rules: [
        {
          name: "Corrective Reading",
          message: "Corrective Reading",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f55e6318cb485584c076499",
          notify: "all",
        },
        {
          name: "Electric Meter Credit Low",
          message: "Electric Meter Credit Low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f1e832082679a052a9d9898",
          notify: "all",
        },
        {
          name: "Electricmeter Usage Limit",
          message: "Electricmeter Usage Limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f1e9d6482679a052a9d9a04",
          notify: "all",
        },
        {
          name: "Geyser Leak Detected",
          message: "Geyser Leak Detected",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5e60fbeeef9d8f483e3c6713",
          notify: "all",
        },
        {
          name: "Watermeter Daily Usage limit",
          message: "Watermeter Daily Usage limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5ec279c4f917d805b74df657",
          notify: "all",
        },
        {
          name: "Watermeter leaking",
          message: "Watermeter leaking",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5eafd16fc453ed7f84c9ae0b",
          notify: "all",
        },
        {
          name: "Level Sensor",
          message: "Level low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "60742e44a3a69b1998f9be45",
          notify: "all",
        },
        // {
        //     "name": " ",
        //     "message": " ",
        //     "repeatInterval": 1,
        //     "repeatCount": 0,
        //     "priority": 10,
        //     "script": "5eafd16fc453ed7f84c9ae0b",
        //     "notify": "all"
        // },
      ],
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site Area",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site ID",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Billing Period",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Report Email",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "VAT",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (KL)",
        },
        {
          value: "false",
          type: "string",
          meta: null,
          key: "Fixed Levies",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 9 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sewerage Percentage",
        },
        {
          value: "true",
          type: "boolean",
          meta: null,
          key: "Is Site",
        },
      ],
    },
  ];
  public readonly models = [
    {
      name: "Sigfox Dry Contact Tag",
      code: "tag.dry",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Manual Water Meter",
      code: "qrw.man",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Lora Nano Tag",
      code: "lora.nanotag",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Manual Electric Meter",
      code: "qre.man",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Water Meter",
      code: "tag.rhw",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Credit Low",
        },
      ],
    },
    {
      name: "Smart Valve Water Meter (Discontinued)",
      code: "tag.h2o",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Electricity Meter",
      code: "tag.rhe",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: 100,
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
      ],
    },
    {
      name: "Smart Geyser",
      code: "atu.log",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
      ],
    },
    {
      name: "Optical Electricity Meter",
      code: "tag.opt",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: 100,
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Credit Low Limit",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "installed",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Corrective Photo",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Corrective Reading Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Corrective Meter Reading",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Corrective Sigfox Reading",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: 1000,
          type: "number",
          meta: null,
          key: "Tick factor",
        },
        {
          value: [],
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Prepaid Water Meter",
      code: "qrw.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qrw.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Prepaid Electricity Meter",
      code: "qre.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qre.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Prepaid Gas Meter",
      code: "qrg.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qrg.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Smart Valve Water Meter V2",
      code: "tag.wmd",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Lora WMD",
      code: "lora.wmd",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Level Sensor",
      code: "tag.lvl",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: 10,
          type: "number",
          meta: null,
          key: "low_level_percentage",
        },
        {
          value: 2850,
          type: "number",
          meta: null,
          key: "sensor_height",
        },
        {
          value: 2700,
          type: "number",
          meta: null,
          key: "overflow_height",
        },
      ],
    },
  ];

  public readonly flavourOptions = [];
  public readonly device_prefix = "";
}

export class ProdSettingsPrecisionUtilities implements BuildSettings {
  //In4mer
  public readonly manageAppUserAccess: boolean = true;
  public readonly creator: string = "In4mDash";
  public readonly apiRoot: string = "https://api.in4mgroup.com:3005/api/usr";
  public readonly apiKey: string =
    "a49c054837326e06a0adb1cd46747afa857080c2a3ca3adc7d3d00213c6bce7f";
  public readonly activateAccount: boolean = true;

  public readonly usersHeader: string = "User";
  public readonly groupsHeader: string = "Site";
  public readonly devicesHeader: string = "Device";
  public readonly linkedUsers: any = [
    {
      //Bradley
      personid: "perOY6a1_8X6qwdYoky1H",
      role: "owner",
    },
  ];
  //Branding + Formatting
  public readonly appFlavour: string = "utilities";
  public readonly tabName: string = "Utilities Dashboard";
  public readonly appName: string = "utilities";
  public readonly fontFamily: string = "'Gill Sans', sans-serif;";
  public readonly loginPanelColor: string = "#333333";
  public readonly loginPanelText = undefined;
  public readonly signInLogo = "assets/img/precision1.png";
  public readonly brandLogo = "assets/img/blank.png";
  public readonly logoSize = "180px";
  public readonly background = "assets/img/bg_dark_1.png";
  public readonly loginWelcome =
    "<h4>Welcome to Precision Utilities</h4><br>Your one stop utilities <br>management tool";
  public readonly bannerTitle = "Utilities Dashboard";
  public readonly bannerLogo = "assets/img/in4mer_white.png";
  public readonly footerCopyRight = "©2021 In4m";
  public readonly bannerTopText = null;
  public readonly privacy = "";
  public readonly terms = "";
  public readonly documents = "";
  public readonly feedback = "";
  public readonly downloadPrefix = "utilities";
  public readonly homeUrl = "https://www.in4mgroup.com/flavours/agri/";
  public readonly flavourType = "utilities";

  public readonly extendedDeviceSettingsMandatory = false;
  public readonly enableTFA = false;
  public readonly showLoginanimation = false;

  // Layout
  public readonly iframeLinks = [
    "https://www.in4mgroup.com/frames/utilities/?$itoken&$ctoken&$role",
  ];
  public readonly showDevTab: boolean = false;
  public readonly devTabAvailable: boolean = true;
  public readonly showIncidentTab: boolean = false;
  public readonly showMapTab: boolean = true;
  public readonly allowChangeAccount: boolean = false;
  public readonly showManageAccounts: boolean = true;
  public readonly showAdmin = false;
  public readonly userManual = null;
  public readonly support = null;
  public readonly addLicencing = true;
  public readonly addLogoOnNewAccount = false;
  public readonly linkedin = null;
  public readonly twitter = null;
  public readonly youtube = null;
  public readonly instagram = null;
  public readonly facebook = null;
  public readonly showFAQs = false;
  public readonly showAppSelector = false;
  public readonly showVerifyUsers = true;
  public readonly showDeviceQuickView = false;

  public readonly bucketDetails = {
    type: "service_account",
    project_id: "ravenhaven-accitrack",
    private_key_id: "980b69e1f720bc1427ee2e4cfb0d64df8311959b",
    private_key:
      "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDJuu3gF8/YMQO1\ng381KdeoFQxYJVyR03+GHdspoD/xKEyfLOdH0rUYQYr2/TwyrdlsE37AlC5hdEu2\nByVpBY+nQ3wjmjdFWj1m1XuqCGgrZHgc7R9oUfJCUJXupflt00OXwfJMrM5oMKJK\nMOXXbrZ7IUmulK6Lx6mWNjlU8tMWrfA4NvzN+l02hKlYAM0+esbcqkg+nrlPibNK\nSg7aLvpV3vvJ+OJLXTgyiNk1hZchhTQuj7I6RijJuvaw/Pyi3LE05cjvkseHgyue\n8Li0kBVG7x9sOTqh5CwIhp+zMovPzUvWgz+HqYSceFefMsgSL969EmluHnDAD4t+\nRjzQo30LAgMBAAECggEADIbAfaFM5TJJ9iv3qq/x9bx020ZapK165jOVZ9TNE6b6\ndwndRK73Us3DGMopwkXcUeM2BDRPWvrTNrbj4k0Xmf3NSBKr6vELDgckmi7SdRtU\ngAtTX3FzNx306XBB+EldkZ9X8d3rJTob4bp+ky2LREMRZbdSzVg1FiBA2B8J74b6\nQEk0fJnrhlGbCAAhAkMcG9jKlncWioBHbRofUm+KhHLDBv1IqJR5klDSitLqr3ym\nDPVbDMSZcngybeoY+10LEZK7DNyxGO3jK4ZiW2HfJC8f9JcKGKGp6X/Ej6thOPU3\nlF1Tc53tu2QGcYt+xiH/c2cHbNFzYYuZJ9QXUWfH1QKBgQDoh9AdJdx5/R462Vn0\nZXy+ZdpFFsy72ivKHCs0CjoLhfDSqubZFA/KkDQb0u4CgM2MCAVuK5qjGusdAlW/\nVRcPNunwUbsejJoSeeN9/cveBp5AZ550Sx31BZuikMDNFXa6DIsZoebtHF9nBqEr\nPSQ3Z66fT4Nhe3toHnN5UfGvrwKBgQDeF0n7cTx74mxKmYDBnD+HARahKWnQ0gI6\nfrOKSaixSjQ1h5owWk1C7vVZqxhRs2lFuc+u5aUvv2D7rSxbcE5tpWxhBkjE91Nn\noHC5ZE/+YTsgxhNK97SZItT3snEvh8PGDzxh2fj8AXMQhFEMzHEN8O25VT+MhBWm\nqnJpkc/jZQKBgC3dtCg7spyBV/glrT+u0QdBUed00tdu9lo8ai0uozpophL30Oca\ntO6wuQaP+ZCW1XR8lI2hnjPz+FJVhpJh91Vx8H0NsgoZk753Om88o3zc81Qi3Dd2\nJaeR/pv3T4BkbnHOTZW1wLYedZb90MaVndIr6l7UMUcGM1ZbQ0234yNTAoGAF9Y0\nEJK0xS8mJFOZaC5W+yx4u09wlgMUTibvKjaBrpWiSOSG/g2TIU34c2lTsOEquVsa\nGVF4i0llJV4O1rmVEVuh6D/+a3WINCUaNCu6EjlpWTkpNPClJ5J/fR5f25QcxRM5\njd8RRCr7qJgrAs6mi7KCMVQe//vlPwAoS4Bk6akCgYBRtG859zgdLlCFOOfQtkLc\nsfZBa8hDxcT5kYBcjIubMa1qT9Og520+q9J/zE5vG+aqStDz6SIwtoUemsohopOx\ntIzZgzZVZMXQhGv1fA4oyfLVbjhgSR8LrJBDE/cHu6DjD6wXP5E7Q2/6sT+5Mnwm\nArABA3/IzJgLb9+/eRzGyQ==\n-----END PRIVATE KEY-----\n",
    client_email: "ravenhaven-accitrack@appspot.gserviceaccount.com",
    client_id: "111620285050654134730",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url:
      "https://www.googleapis.com/robot/v1/metadata/x509/ravenhaven-accitrack%40appspot.gserviceaccount.com",
  };

  //IoT setup
  //Define rules
  public readonly classTypes = [
    {
      name: "Site",
      rules: [
        {
          name: "Corrective Reading",
          message: "Corrective Reading",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f55e6318cb485584c076499",
          notify: "all",
        },
        {
          name: "Electric Meter Credit Low",
          message: "Electric Meter Credit Low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f1e832082679a052a9d9898",
          notify: "all",
        },
        {
          name: "Electricmeter Usage Limit",
          message: "Electricmeter Usage Limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f1e9d6482679a052a9d9a04",
          notify: "all",
        },
        {
          name: "Geyser Leak Detected",
          message: "Geyser Leak Detected",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5e60fbeeef9d8f483e3c6713",
          notify: "all",
        },
        // {
        //     "name": " ",
        //     "message": " ",
        //     "repeatInterval": 1,
        //     "repeatCount": 0,
        //     "priority": 10,
        //     "script": "5eafd16fc453ed7f84c9ae0b",
        //     "notify": "all"
        // },

        {
          name: "Watermeter Daily Usage limit",
          message: "Watermeter Daily Usage limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5ec279c4f917d805b74df657",
          notify: "all",
        },
        {
          name: "Watermeter leaking",
          message: "Watermeter leaking",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5eafd16fc453ed7f84c9ae0b",
          notify: "all",
          schedule: [
            {
              tag: "New Timer",
              repeat: "every",
              days: [],
              hourOn: 22,
              minOn: 0,
              hourOff: 3,
              minOff: 0,
            },
          ],
        },
        {
          name: "Level Sensor",
          message: "Level low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "60742e44a3a69b1998f9be45",
          notify: "all",
        },
      ],
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site Area",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site ID",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Billing Period",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Report Email",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "VAT",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (KL)",
        },
        {
          value: "false",
          type: "string",
          meta: null,
          key: "Fixed Levies",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 9 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sewerage Percentage",
        },
        {
          value: "true",
          type: "boolean",
          meta: null,
          key: "Is Site",
        },
      ],
    },
  ];
  public readonly models = [
     //TODO: revisit, spur of the moment madness adding this before vacation (some client will lose their shit if this isn't there)
     {
      name: "ABB Electricity Meter",
      code: "lora.abbelec",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Credit Low",
        },
      ],
    },
    {
      name: "Sigfox Dry Contact Tag",
      code: "tag.dry",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Manual Water Meter",
      code: "qrw.man",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Manual Electric Meter",
      code: "qre.man",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Water Meter",
      code: "tag.rhw",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Credit Low",
        },
      ],
    },
    {
      name: "Smart Valve Water Meter (Discontinued)",
      code: "tag.h2o",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Electricity Meter",
      code: "tag.rhe",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: 100,
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
      ],
    },
    {
      name: "Smart Geyser",
      code: "atu.log",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
      ],
    },
    {
      name: "Optical Electricity Meter",
      code: "tag.opt",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: 100,
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Credit Low Limit",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "installed",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Corrective Photo",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Corrective Reading Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Corrective Meter Reading",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Corrective Sigfox Reading",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: 1000,
          type: "number",
          meta: null,
          key: "Tick factor",
        },
        {
          value: [],
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Prepaid Water Meter",
      code: "qrw.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qrw.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Prepaid Electricity Meter",
      code: "qre.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qre.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Prepaid Gas Meter",
      code: "qrg.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qrg.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Smart Valve Water Meter V2",
      code: "tag.wmd",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Lora WMD",
      code: "lora.wmd",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Level Sensor",
      code: "tag.lvl",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: 10,
          type: "number",
          meta: null,
          key: "low_level_percentage",
        },
        {
          value: 2850,
          type: "number",
          meta: null,
          key: "sensor_height",
        },
        {
          value: 2700,
          type: "number",
          meta: null,
          key: "overflow_height",
        },
      ],
    },
  ];

  public readonly flavourOptions = [];
  public readonly device_prefix = "";
}

export class ProdSettingsPoolUtilities implements BuildSettings {
  //In4mer
  public readonly manageAppUserAccess: boolean = false;
  public readonly creator: string = "In4mDash";
  public readonly apiRoot: string = "https://api.in4mgroup.com:3005/api/usr";
  // public readonly apiKey: string = "78d8a6e69bc918cee5bc5109caf314f64c07e20bb440819cbc501d365dfc0e2d";
  public readonly apiKey: string =
    "a49c054837326e06a0adb1cd46747afa857080c2a3ca3adc7d3d00213c6bce7f";
  public readonly activateAccount: boolean = true;

  public readonly usersHeader: string = "User";
  public readonly groupsHeader: string = "Site";
  public readonly devicesHeader: string = "Device";
  public readonly linkedUsers: any = [];
  //Branding + Formatting
  public readonly appFlavour: string = "utilities";
  public readonly tabName: string = "Utilities Dashboard";
  public readonly appName: string = "utilities";
  public readonly fontFamily: string = "'Gill Sans', sans-serif;";
  public readonly loginPanelColor: string = "#333333";
  public readonly loginPanelText = undefined;
  public readonly signInLogo = "assets/img/tools_duo.png";
  public readonly brandLogo = "assets/img/blank.png";
  public readonly logoSize = "180px";
  public readonly background = "assets/img/bg_dark_1.png";
  public readonly loginWelcome =
    "<h4>Welcome to Utilities Dashboard</h4><br>Your one stop utilities <br>management tool";
  public readonly bannerTitle = "Utilities Dashboard";
  public readonly bannerLogo = "assets/img/in4mer_white.png";
  public readonly footerCopyRight = "©2021 In4m";
  public readonly bannerTopText = null;
  public readonly privacy = "";
  public readonly terms = "";
  public readonly documents = "";
  public readonly feedback = "";
  public readonly downloadPrefix = "utilities";
  public readonly homeUrl = "https://www.appsafest.com/dashboard/safest/";
  public readonly flavourType = "utilities";

  public readonly extendedDeviceSettingsMandatory = false;
  public readonly enableTFA = false;
  public readonly showLoginanimation = true;

  // Layout
  public readonly iframeLinks = [
    "https://www.in4mgroup.com/frames/utilities/?$itoken&$ctoken&$role",
  ];
  public readonly showDevTab: boolean = true;
  public readonly devTabAvailable: boolean = true;
  public readonly showIncidentTab: boolean = false;
  public readonly showMapTab: boolean = true;
  public readonly allowChangeAccount: boolean = false;
  public readonly showManageAccounts: boolean = true;
  public readonly showAdmin = false;
  public readonly userManual = null;
  public readonly support = null;
  public readonly addLicencing = true;
  public readonly addLogoOnNewAccount = false;
  public readonly linkedin = null;
  public readonly twitter = null;
  public readonly youtube = null;
  public readonly instagram = null;
  public readonly facebook = null;
  public readonly showFAQs = false;
  public readonly showAppSelector = true;
  public readonly showVerifyUsers = true;
  public readonly showDeviceQuickView = false;

  public readonly bucketDetails = {
    type: "service_account",
    project_id: "ravenhaven-accitrack",
    private_key_id: "980b69e1f720bc1427ee2e4cfb0d64df8311959b",
    private_key:
      "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDJuu3gF8/YMQO1\ng381KdeoFQxYJVyR03+GHdspoD/xKEyfLOdH0rUYQYr2/TwyrdlsE37AlC5hdEu2\nByVpBY+nQ3wjmjdFWj1m1XuqCGgrZHgc7R9oUfJCUJXupflt00OXwfJMrM5oMKJK\nMOXXbrZ7IUmulK6Lx6mWNjlU8tMWrfA4NvzN+l02hKlYAM0+esbcqkg+nrlPibNK\nSg7aLvpV3vvJ+OJLXTgyiNk1hZchhTQuj7I6RijJuvaw/Pyi3LE05cjvkseHgyue\n8Li0kBVG7x9sOTqh5CwIhp+zMovPzUvWgz+HqYSceFefMsgSL969EmluHnDAD4t+\nRjzQo30LAgMBAAECggEADIbAfaFM5TJJ9iv3qq/x9bx020ZapK165jOVZ9TNE6b6\ndwndRK73Us3DGMopwkXcUeM2BDRPWvrTNrbj4k0Xmf3NSBKr6vELDgckmi7SdRtU\ngAtTX3FzNx306XBB+EldkZ9X8d3rJTob4bp+ky2LREMRZbdSzVg1FiBA2B8J74b6\nQEk0fJnrhlGbCAAhAkMcG9jKlncWioBHbRofUm+KhHLDBv1IqJR5klDSitLqr3ym\nDPVbDMSZcngybeoY+10LEZK7DNyxGO3jK4ZiW2HfJC8f9JcKGKGp6X/Ej6thOPU3\nlF1Tc53tu2QGcYt+xiH/c2cHbNFzYYuZJ9QXUWfH1QKBgQDoh9AdJdx5/R462Vn0\nZXy+ZdpFFsy72ivKHCs0CjoLhfDSqubZFA/KkDQb0u4CgM2MCAVuK5qjGusdAlW/\nVRcPNunwUbsejJoSeeN9/cveBp5AZ550Sx31BZuikMDNFXa6DIsZoebtHF9nBqEr\nPSQ3Z66fT4Nhe3toHnN5UfGvrwKBgQDeF0n7cTx74mxKmYDBnD+HARahKWnQ0gI6\nfrOKSaixSjQ1h5owWk1C7vVZqxhRs2lFuc+u5aUvv2D7rSxbcE5tpWxhBkjE91Nn\noHC5ZE/+YTsgxhNK97SZItT3snEvh8PGDzxh2fj8AXMQhFEMzHEN8O25VT+MhBWm\nqnJpkc/jZQKBgC3dtCg7spyBV/glrT+u0QdBUed00tdu9lo8ai0uozpophL30Oca\ntO6wuQaP+ZCW1XR8lI2hnjPz+FJVhpJh91Vx8H0NsgoZk753Om88o3zc81Qi3Dd2\nJaeR/pv3T4BkbnHOTZW1wLYedZb90MaVndIr6l7UMUcGM1ZbQ0234yNTAoGAF9Y0\nEJK0xS8mJFOZaC5W+yx4u09wlgMUTibvKjaBrpWiSOSG/g2TIU34c2lTsOEquVsa\nGVF4i0llJV4O1rmVEVuh6D/+a3WINCUaNCu6EjlpWTkpNPClJ5J/fR5f25QcxRM5\njd8RRCr7qJgrAs6mi7KCMVQe//vlPwAoS4Bk6akCgYBRtG859zgdLlCFOOfQtkLc\nsfZBa8hDxcT5kYBcjIubMa1qT9Og520+q9J/zE5vG+aqStDz6SIwtoUemsohopOx\ntIzZgzZVZMXQhGv1fA4oyfLVbjhgSR8LrJBDE/cHu6DjD6wXP5E7Q2/6sT+5Mnwm\nArABA3/IzJgLb9+/eRzGyQ==\n-----END PRIVATE KEY-----\n",
    client_email: "ravenhaven-accitrack@appspot.gserviceaccount.com",
    client_id: "111620285050654134730",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url:
      "https://www.googleapis.com/robot/v1/metadata/x509/ravenhaven-accitrack%40appspot.gserviceaccount.com",
  };

  //IoT setup
  //Define rules
  public readonly classTypes = [
    {
      name: "Site",
      rules: [
        // Corrective Reading
        {
          name: "Corrective Reading",
          message: "Corrective Reading",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 1,
          script: "5f55e6318cb485584c076499",
          notify: "all",
        },
        //Electric Meter Credit Low
        {
          name: "Electric Meter Credit Low",
          message: "Electric Meter Credit Low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 1,
          script: "5f1e832082679a052a9d9898",
          notify: "all",
        },
        //Electricmeter Usage Limit
        {
          name: "Electricmeter Usage Limit",
          message: "Electricmeter Usage Limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f1e9d6482679a052a9d9a04",
          notify: "all",
        },
        // Watermeter Daily Usage limit
        {
          name: "Watermeter Daily Usage limit",
          message: "Watermeter Daily Usage limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 4,
          script: "5ec279c4f917d805b74df657",
          notify: "all",
        },
        // Watermeter leaking
        {
          name: "Watermeter leaking",
          message: "Watermeter leaking",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5eafd16fc453ed7f84c9ae0b",
          notify: "all",
        },
        // Level Sensor : Level low
        {
          name: "Level Sensor",
          message: "Level low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 8,
          script: "60742e44a3a69b1998f9be45",
          notify: "all",
        },
        // Battery low
        {
          name: "Battery low",
          message: "Battery low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60a38840361c0d0e49d5c18b",
          notify: "all",
        },
        // Weak signal
        {
          name: "Weak signal",
          message: "Weak signal",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60a3995b361c0d0e49d5c18f",
          notify: "all",
        },
        // Under/Over Volt -- 4
        {
          name: "Over/Under voltage",
          message: "Over/Under voltage",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60a3a1a9361c0d0e49d5c192",
          notify: "all",
        },
        // Electricity tamper -- 5
        {
          name: "Electricity meter tamper",
          message: "Electricity meter tamper",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60a39f18361c0d0e49d5c191",
          notify: "all",
        },
        // Overflow -- 3
        {
          name: "Geyser overflow",
          message: "Geyser overflow detected",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60a3a81a361c0d0e49d5c194",
          notify: "all",
        },
        // Faulty probe -- 2
        {
          name: "Faulty probe",
          message: "Temperature probe faulty",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60a3ab3e361c0d0e49d5c196",
          notify: "all",
        },
        // Temp missing -- 8
        {
          name: "Temperature device missing",
          message: "Temperature device missing",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "608bece4f1eaff27790b5479",
          notify: "all",
        },
        // Meter down  -- 1
        {
          name: "Device missing",
          message: "Device missing",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 7,
          script: "60b73ba1fe9acd467f747ab9",
          notify: "all",
        },
        //Temperature range
        {
          name: "Temperature range",
          message: "Temperature outside of allowed range",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 2,
          script: "600a98189c89b16addb3721f",
          notify: "all",
        },
        //Temperature report
        {
          name: "Temperature report",
          message: "Report current temperature",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 2,
          script: "608bd221f1eaff27790b5406",
          notify: "all",
        },
        //Pool tamper
        {
          name: "Device Tamper",
          message: "Pool Water Meter Tamper",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 2,
          script: "60d19e96882fab602e0ed566",
          notify: "all",
        },
        {
          name: "Device Toggle",
          message: "Pool Water Meter Toggle",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 2,
          script: "60d5a2449dc6f40f7ccd5c4b",
          notify: "all",
        },
      ],
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site Area",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site ID",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Billing Period",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Report Email",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "VAT",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (KL)",
        },
        {
          value: "false",
          type: "string",
          meta: null,
          key: "Fixed Levies",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 9 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sewerage Percentage",
        },
        {
          value: "true",
          type: "boolean",
          meta: null,
          key: "Is Site",
        },
      ],
    },
  ];

  public readonly models = [
    {
      name: "Watermeter",
      code: "rom.ptw",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Electricity meter",
      code: "rom.pte",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
  ];

  public readonly flavourOptions = [];
  public readonly device_prefix = "";
}

export class ProdSettingsThermologix implements BuildSettings {
  //In4mer
  public readonly manageAppUserAccess: boolean = false;
  public readonly creator: string = "In4mDash";
  public readonly apiRoot: string = "https://api.in4mgroup.com:3005/api/usr";
  // public readonly apiKey: string = "78d8a6e69bc918cee5bc5109caf314f64c07e20bb440819cbc501d365dfc0e2d";
  public readonly apiKey: string =
    "a49c054837326e06a0adb1cd46747afa857080c2a3ca3adc7d3d00213c6bce7f";
  public readonly activateAccount: boolean = true;

  public readonly usersHeader: string = "User";
  public readonly groupsHeader: string = "Site";
  public readonly devicesHeader: string = "Device";
  public readonly linkedUsers: any = [];
  //Branding + Formatting
  public readonly appFlavour: string = "utilities";
  public readonly tabName: string = "Thermologix Dashboard";
  public readonly appName: string = "utilities";
  public readonly fontFamily: string = "'Gill Sans', sans-serif;";
  public readonly loginPanelColor: string = "#333333";
  public readonly loginPanelText = undefined;
  public readonly signInLogo = "assets/img/thermologix.png";
  public readonly brandLogo = "assets/img/blank.png";
  public readonly logoSize = "180px";
  public readonly background = "assets/img/bg_dark_1.png";
  public readonly loginWelcome =
    "<h4>Welcome to Thermologix Dashboard</h4><br>Your one stop thermal <br>management tool";
  public readonly bannerTitle = "Thermologix Dashboard";
  public readonly bannerLogo = "assets/img/in4mer_white.png";
  public readonly footerCopyRight = "©2021 In4m";
  public readonly bannerTopText = null;
  public readonly privacy = "";
  public readonly terms = "";
  public readonly documents = "";
  public readonly feedback = "";
  public readonly downloadPrefix = "utilities";
  public readonly homeUrl = "https://www.appsafest.com/dashboard/safest/";
  public readonly flavourType = "thermologix";

  public readonly extendedDeviceSettingsMandatory = false;
  public readonly enableTFA = false;

  // Layout
  public readonly iframeLinks = [
    "https://www.in4mgroup.com/frames/utilities/?$itoken&$ctoken&$role&$ftp",
  ];
  public readonly showDevTab: boolean = true;
  public readonly devTabAvailable: boolean = true;
  public readonly showIncidentTab: boolean = false;
  public readonly showMapTab: boolean = true;
  public readonly allowChangeAccount: boolean = false;
  public readonly showManageAccounts: boolean = true;
  public readonly showAdmin = false;
  public readonly userManual = null;
  public readonly support = null;
  public readonly addLicencing = true;
  public readonly addLogoOnNewAccount = false;
  public readonly linkedin = null;
  public readonly twitter = null;
  public readonly youtube = null;
  public readonly instagram = null;
  public readonly facebook = null;
  public readonly showFAQs = false;
  public readonly showAppSelector = true;
  public readonly showVerifyUsers = true;
  public readonly showDeviceQuickView = false;
  public readonly showLoginanimation = false;

  public readonly bucketDetails = {
    type: "service_account",
    project_id: "ravenhaven-accitrack",
    private_key_id: "980b69e1f720bc1427ee2e4cfb0d64df8311959b",
    private_key:
      "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDJuu3gF8/YMQO1\ng381KdeoFQxYJVyR03+GHdspoD/xKEyfLOdH0rUYQYr2/TwyrdlsE37AlC5hdEu2\nByVpBY+nQ3wjmjdFWj1m1XuqCGgrZHgc7R9oUfJCUJXupflt00OXwfJMrM5oMKJK\nMOXXbrZ7IUmulK6Lx6mWNjlU8tMWrfA4NvzN+l02hKlYAM0+esbcqkg+nrlPibNK\nSg7aLvpV3vvJ+OJLXTgyiNk1hZchhTQuj7I6RijJuvaw/Pyi3LE05cjvkseHgyue\n8Li0kBVG7x9sOTqh5CwIhp+zMovPzUvWgz+HqYSceFefMsgSL969EmluHnDAD4t+\nRjzQo30LAgMBAAECggEADIbAfaFM5TJJ9iv3qq/x9bx020ZapK165jOVZ9TNE6b6\ndwndRK73Us3DGMopwkXcUeM2BDRPWvrTNrbj4k0Xmf3NSBKr6vELDgckmi7SdRtU\ngAtTX3FzNx306XBB+EldkZ9X8d3rJTob4bp+ky2LREMRZbdSzVg1FiBA2B8J74b6\nQEk0fJnrhlGbCAAhAkMcG9jKlncWioBHbRofUm+KhHLDBv1IqJR5klDSitLqr3ym\nDPVbDMSZcngybeoY+10LEZK7DNyxGO3jK4ZiW2HfJC8f9JcKGKGp6X/Ej6thOPU3\nlF1Tc53tu2QGcYt+xiH/c2cHbNFzYYuZJ9QXUWfH1QKBgQDoh9AdJdx5/R462Vn0\nZXy+ZdpFFsy72ivKHCs0CjoLhfDSqubZFA/KkDQb0u4CgM2MCAVuK5qjGusdAlW/\nVRcPNunwUbsejJoSeeN9/cveBp5AZ550Sx31BZuikMDNFXa6DIsZoebtHF9nBqEr\nPSQ3Z66fT4Nhe3toHnN5UfGvrwKBgQDeF0n7cTx74mxKmYDBnD+HARahKWnQ0gI6\nfrOKSaixSjQ1h5owWk1C7vVZqxhRs2lFuc+u5aUvv2D7rSxbcE5tpWxhBkjE91Nn\noHC5ZE/+YTsgxhNK97SZItT3snEvh8PGDzxh2fj8AXMQhFEMzHEN8O25VT+MhBWm\nqnJpkc/jZQKBgC3dtCg7spyBV/glrT+u0QdBUed00tdu9lo8ai0uozpophL30Oca\ntO6wuQaP+ZCW1XR8lI2hnjPz+FJVhpJh91Vx8H0NsgoZk753Om88o3zc81Qi3Dd2\nJaeR/pv3T4BkbnHOTZW1wLYedZb90MaVndIr6l7UMUcGM1ZbQ0234yNTAoGAF9Y0\nEJK0xS8mJFOZaC5W+yx4u09wlgMUTibvKjaBrpWiSOSG/g2TIU34c2lTsOEquVsa\nGVF4i0llJV4O1rmVEVuh6D/+a3WINCUaNCu6EjlpWTkpNPClJ5J/fR5f25QcxRM5\njd8RRCr7qJgrAs6mi7KCMVQe//vlPwAoS4Bk6akCgYBRtG859zgdLlCFOOfQtkLc\nsfZBa8hDxcT5kYBcjIubMa1qT9Og520+q9J/zE5vG+aqStDz6SIwtoUemsohopOx\ntIzZgzZVZMXQhGv1fA4oyfLVbjhgSR8LrJBDE/cHu6DjD6wXP5E7Q2/6sT+5Mnwm\nArABA3/IzJgLb9+/eRzGyQ==\n-----END PRIVATE KEY-----\n",
    client_email: "ravenhaven-accitrack@appspot.gserviceaccount.com",
    client_id: "111620285050654134730",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url:
      "https://www.googleapis.com/robot/v1/metadata/x509/ravenhaven-accitrack%40appspot.gserviceaccount.com",
  };

  //IoT setup
  //Define rules
  // public readonly classTypes = [
  //   {
  //     name: "Site",
  //     rules: [
  //       {
  //         name: "Corrective Reading",
  //         message: "Corrective Reading",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "5f55e6318cb485584c076499",
  //         notify: "all",
  //       },
  //       {
  //         name: "Electric Meter Credit Low",
  //         message: "Electric Meter Credit Low",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "5f1e832082679a052a9d9898",
  //         notify: "all",
  //       },
  //       {
  //         name: "Electricmeter Usage Limit",
  //         message: "Electricmeter Usage Limit",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "5f1e9d6482679a052a9d9a04",
  //         notify: "all",
  //       },
  //       {
  //         name: "Geyser Leak Detected",
  //         message: "Geyser Leak Detected",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "5e60fbeeef9d8f483e3c6713",
  //         notify: "all",
  //       },
  //       {
  //         name: "Watermeter Daily Usage limit",
  //         message: "Watermeter Daily Usage limit",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "5ec279c4f917d805b74df657",
  //         notify: "all",
  //       },
  //       {
  //         name: "Watermeter leaking",
  //         message: "Watermeter leaking",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "5eafd16fc453ed7f84c9ae0b",
  //         notify: "all",
  //       },
  //       {
  //         name: "Level Sensor",
  //         message: "Level low",
  //         repeatInterval: 1,
  //         repeatCount: 0,
  //         priority: 10,
  //         script: "60742e44a3a69b1998f9be45",
  //         notify: "all",
  //       },
  //       // {
  //       //     "name": " ",
  //       //     "message": " ",
  //       //     "repeatInterval": 1,
  //       //     "repeatCount": 0,
  //       //     "priority": 10,
  //       //     "script": "5eafd16fc453ed7f84c9ae0b",
  //       //     "notify": "all"
  //       // },
  //     ],
  //     specifics: [
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Site Area",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Site ID",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Billing Period",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Report Email",
  //       },
  //       {
  //         value: false,
  //         type: "string",
  //         meta: null,
  //         key: "VAT",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 1 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 2 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 3 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 4 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 5 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 6 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 7 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 8 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 9 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 10 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 1 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 2 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 3 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 4 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 5 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 6 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 7 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 8 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 9 (KL)",
  //       },
  //       {
  //         value: "false",
  //         type: "string",
  //         meta: null,
  //         key: "Fixed Levies",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 1 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 2 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 3 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 4 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 5 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 6 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 7 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 8 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 9 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step Rate 10 (ZAR/kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 1 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 2 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 3 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 4 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 5 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 6 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 7 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 8 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Step 9 (kWh)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 1 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 2 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 3 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 4 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 5 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 6 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 7 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 8 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step 9 (KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 1 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 2 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 3 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 4 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 5 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 6 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 7 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 8 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 9 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sew Step Rate 10 (ZAR/KL)",
  //       },
  //       {
  //         value: "",
  //         type: "string",
  //         meta: null,
  //         key: "Sewerage Percentage",
  //       },
  //       {
  //         value: "true",
  //         type: "boolean",
  //         meta: null,
  //         key: "Is Site",
  //       },
  //     ],
  //   },
  // ];

  public readonly classTypes = utilityClasses;

  public readonly models = [
    {
      name: "Sigfox Dry Contact Tag",
      code: "tag.dry",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Lora Nano Tag",
      code: "lora.nanotag",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Lora Temperature Tag",
      code: "lora.tmp",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Sigfox Temperature Tag",
      code: "tag.tmp",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "RF Temperature Tag",
      code: "tag.tmo",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
      ],
    },
    {
      name: "Manual Water Meter",
      code: "qrw.man",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Manual Electric Meter",
      code: "qre.man",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Water Meter",
      code: "tag.rhw",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Credit Low",
        },
      ],
    },
    {
      name: "Smart Valve Water Meter (Discontinued)",
      code: "tag.h2o",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Electricity Meter",
      code: "tag.rhe",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: 100,
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
      ],
    },
    {
      name: "Smart Geyser",
      code: "atu.log",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
      ],
    },
    {
      name: "Optical Electricity Meter",
      code: "tag.opt",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: 100,
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Credit Low Limit",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "installed",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Corrective Photo",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Corrective Reading Date",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Corrective Meter Reading",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Corrective Sigfox Reading",
        },
        {
          value: 0,
          type: "number",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: 1000,
          type: "number",
          meta: null,
          key: "Tick factor",
        },
        {
          value: [],
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Prepaid Water Meter",
      code: "qrw.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qrw.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Prepaid Electricity Meter",
      code: "qre.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qre.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Prepaid Gas Meter",
      code: "qrg.pre",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "qrg.pre",
          type: "string",
          meta: null,
          key: "Meter Model",
        },

        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
      ],
    },
    {
      name: "Smart Valve Water Meter V2",
      code: "tag.wmd",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Lora WMD",
      code: "lora.wmd",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
  ];

  public readonly flavourOptions = [];
  public readonly device_prefix = "";
}

export class ProdSettingsPrecisionFarming implements BuildSettings {
  //In4mer
  public readonly manageAppUserAccess: boolean = false;
  public readonly creator: string = "In4mDash";
  public readonly apiRoot: string = "https://api.in4mgroup.com:3005/api/usr";
  public readonly apiKey: string =
    "79781f129b2cf65bdd3dbdd159e1a6a1bbc57038572dda77aa246fda92f2c31f";
  public readonly activateAccount: boolean = true;

  public readonly usersHeader: string = "User";
  public readonly groupsHeader: string = "Site";
  public readonly devicesHeader: string = "Device";
  public readonly linkedUsers: any = [];
  //Branding + Formatting
  public readonly appFlavour: string = "precisionfarming";
  public readonly tabName: string = "Precision Farming";
  public readonly appName: string = "precisionfarming";
  public readonly fontFamily: string = "'Gill Sans', sans-serif;";
  public readonly loginPanelColor: string = "#333333";
  public readonly loginPanelText = undefined;
  public readonly signInLogo = "assets/img/tractor_duo.png";
  public readonly brandLogo = "assets/img/blank.png";
  public readonly logoSize = "180px";
  public readonly background = "assets/img/bg_dark_1.png";
  public readonly loginWelcome =
    "<h4>Welcome to Precision Farming Dashboard</h4><br>Your one stop agricultural <br>management tool";
  public readonly bannerTitle = "Precision Farming";
  public readonly bannerLogo = "assets/img/in4mer_white.png";
  public readonly footerCopyRight = "©2021 In4m";
  public readonly bannerTopText = null;
  public readonly privacy = "";
  public readonly terms = "";
  public readonly documents = "";
  public readonly feedback = "";
  public readonly downloadPrefix = "precisionfarming";
  public readonly homeUrl = "https://www.appsafest.com/dashboard/safest/";
  public readonly flavourType = "utilities";

  public readonly extendedDeviceSettingsMandatory = false;
  public readonly enableTFA = false;

  // Layout
  public readonly iframeLinks = [
    "https://www.in4mgroup.com/frames/agri/?$itoken&$flavour&$ctoken&$role",
  ];
  public readonly showDevTab: boolean = true;
  public readonly devTabAvailable: boolean = true;
  public readonly showIncidentTab: boolean = false;
  public readonly showMapTab: boolean = true;
  public readonly allowChangeAccount: boolean = false;
  public readonly showManageAccounts: boolean = true;
  public readonly showAdmin = false;
  public readonly userManual = null;
  public readonly support = null;
  public readonly addLicencing = true;
  public readonly addLogoOnNewAccount = false;
  public readonly linkedin = null;
  public readonly twitter = null;
  public readonly youtube = null;
  public readonly instagram = null;
  public readonly facebook = null;
  public readonly showFAQs = false;
  public readonly showAppSelector = true;
  public readonly showVerifyUsers = false;
  public readonly showDeviceQuickView = false;
  public readonly showLoginanimation = true;

  public readonly bucketDetails = {
    type: "service_account",
    project_id: "ravenhaven-accitrack",
    private_key_id: "980b69e1f720bc1427ee2e4cfb0d64df8311959b",
    private_key:
      "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDJuu3gF8/YMQO1\ng381KdeoFQxYJVyR03+GHdspoD/xKEyfLOdH0rUYQYr2/TwyrdlsE37AlC5hdEu2\nByVpBY+nQ3wjmjdFWj1m1XuqCGgrZHgc7R9oUfJCUJXupflt00OXwfJMrM5oMKJK\nMOXXbrZ7IUmulK6Lx6mWNjlU8tMWrfA4NvzN+l02hKlYAM0+esbcqkg+nrlPibNK\nSg7aLvpV3vvJ+OJLXTgyiNk1hZchhTQuj7I6RijJuvaw/Pyi3LE05cjvkseHgyue\n8Li0kBVG7x9sOTqh5CwIhp+zMovPzUvWgz+HqYSceFefMsgSL969EmluHnDAD4t+\nRjzQo30LAgMBAAECggEADIbAfaFM5TJJ9iv3qq/x9bx020ZapK165jOVZ9TNE6b6\ndwndRK73Us3DGMopwkXcUeM2BDRPWvrTNrbj4k0Xmf3NSBKr6vELDgckmi7SdRtU\ngAtTX3FzNx306XBB+EldkZ9X8d3rJTob4bp+ky2LREMRZbdSzVg1FiBA2B8J74b6\nQEk0fJnrhlGbCAAhAkMcG9jKlncWioBHbRofUm+KhHLDBv1IqJR5klDSitLqr3ym\nDPVbDMSZcngybeoY+10LEZK7DNyxGO3jK4ZiW2HfJC8f9JcKGKGp6X/Ej6thOPU3\nlF1Tc53tu2QGcYt+xiH/c2cHbNFzYYuZJ9QXUWfH1QKBgQDoh9AdJdx5/R462Vn0\nZXy+ZdpFFsy72ivKHCs0CjoLhfDSqubZFA/KkDQb0u4CgM2MCAVuK5qjGusdAlW/\nVRcPNunwUbsejJoSeeN9/cveBp5AZ550Sx31BZuikMDNFXa6DIsZoebtHF9nBqEr\nPSQ3Z66fT4Nhe3toHnN5UfGvrwKBgQDeF0n7cTx74mxKmYDBnD+HARahKWnQ0gI6\nfrOKSaixSjQ1h5owWk1C7vVZqxhRs2lFuc+u5aUvv2D7rSxbcE5tpWxhBkjE91Nn\noHC5ZE/+YTsgxhNK97SZItT3snEvh8PGDzxh2fj8AXMQhFEMzHEN8O25VT+MhBWm\nqnJpkc/jZQKBgC3dtCg7spyBV/glrT+u0QdBUed00tdu9lo8ai0uozpophL30Oca\ntO6wuQaP+ZCW1XR8lI2hnjPz+FJVhpJh91Vx8H0NsgoZk753Om88o3zc81Qi3Dd2\nJaeR/pv3T4BkbnHOTZW1wLYedZb90MaVndIr6l7UMUcGM1ZbQ0234yNTAoGAF9Y0\nEJK0xS8mJFOZaC5W+yx4u09wlgMUTibvKjaBrpWiSOSG/g2TIU34c2lTsOEquVsa\nGVF4i0llJV4O1rmVEVuh6D/+a3WINCUaNCu6EjlpWTkpNPClJ5J/fR5f25QcxRM5\njd8RRCr7qJgrAs6mi7KCMVQe//vlPwAoS4Bk6akCgYBRtG859zgdLlCFOOfQtkLc\nsfZBa8hDxcT5kYBcjIubMa1qT9Og520+q9J/zE5vG+aqStDz6SIwtoUemsohopOx\ntIzZgzZVZMXQhGv1fA4oyfLVbjhgSR8LrJBDE/cHu6DjD6wXP5E7Q2/6sT+5Mnwm\nArABA3/IzJgLb9+/eRzGyQ==\n-----END PRIVATE KEY-----\n",
    client_email: "ravenhaven-accitrack@appspot.gserviceaccount.com",
    client_id: "111620285050654134730",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url:
      "https://www.googleapis.com/robot/v1/metadata/x509/ravenhaven-accitrack%40appspot.gserviceaccount.com",
  };

  //IoT setup
  //Define rules
  public readonly classTypes = [
    {
      name: "Site",
      rules: [
        {
          name: "Corrective Reading",
          message: "Corrective Reading",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f55e6318cb485584c076499",
          notify: "all",
        },
        {
          name: "Electric Meter Credit Low",
          message: "Electric Meter Credit Low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f1e832082679a052a9d9898",
          notify: "all",
        },
        {
          name: "Electricmeter Usage Limit",
          message: "Electricmeter Usage Limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5f1e9d6482679a052a9d9a04",
          notify: "all",
        },
        {
          name: "Geyser Leak Detected",
          message: "Geyser Leak Detected",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5e60fbeeef9d8f483e3c6713",
          notify: "all",
        },
        {
          name: "Watermeter Daily Usage limit",
          message: "Watermeter Daily Usage limit",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5ec279c4f917d805b74df657",
          notify: "all",
        },
        {
          name: "Watermeter leaking",
          message: "Watermeter leaking",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "5eafd16fc453ed7f84c9ae0b",
          notify: "all",
        },
        {
          name: "Level Sensor",
          message: "Level low",
          repeatInterval: 1,
          repeatCount: 0,
          priority: 10,
          script: "60742e44a3a69b1998f9be45",
          notify: "all",
        },
        // {
        //     "name": " ",
        //     "message": " ",
        //     "repeatInterval": 1,
        //     "repeatCount": 0,
        //     "priority": 10,
        //     "script": "5eafd16fc453ed7f84c9ae0b",
        //     "notify": "all"
        //         }
      ],
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site Area",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site ID",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Billing Period",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Report Email",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "VAT",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (KL)",
        },
        {
          value: "false",
          type: "string",
          meta: null,
          key: "Fixed Levies",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 9 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sewerage Percentage",
        },
        {
          value: "true",
          type: "boolean",
          meta: null,
          key: "Is Site",
        },
      ],
    },
  ];
  public readonly models = [
    {
      name: "RPS",
      code: "rps.agr",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM4",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM5",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM6",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM7",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "WM8",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN4",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN5",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN6",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN7",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "IN8",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config1",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config2",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config3",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config4",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config5",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config6",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config7",
        },
        {
          value: {
            lowMoist: 20,
            highMoist: 60,
            lowTemp: 2,
            highTemp: 30,
            level: 3,
            switchOnMoisture: true,
            switchonTemp: false,
          },
          type: "any",
          meta: null,
          key: "Config8",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
    {
      name: "Smart Water Meter",
      code: "tag.rhw",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sigfox Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Credit Low",
        },
      ],
    },
    {
      name: "Probe",
      code: "rps.tmp",
      specifics: [],
    },
  ];
  public readonly device_prefix = "";
  public readonly flavourOptions = [];
}

export class ProdSettingsFlowcheckUtilities implements BuildSettings {
  //In4mer
  public readonly manageAppUserAccess: boolean = false;
  public readonly creator: string = "Flowcheck";

  public readonly apiRoot: string = "https://api.in4mgroup.com:3005/api/usr";
  public readonly apiKey: string =
    "329bfb5cf915a6e22aa64b2217b9febedcd4397146b4aa5dddb001e6aaafbb14";
  public readonly activateAccount: boolean = false;

  public readonly usersHeader: string = "User";
  public readonly groupsHeader: string = "Site";
  public readonly devicesHeader: string = "Device";
  public readonly linkedUsers: any = [
    {
      //Lourens
      personid: "perdQDCtUFqpKkEb4Xz55",
      role: "owner",
    },
  ];

  //Branding + Formatting
  public readonly appFlavour: string = "flowcheck";
  public readonly tabName: string = "Flocheck Dashboard";
  public readonly appName: string = "flowcheck";
  public readonly fontFamily: string = "'Gill Sans', sans-serif;";
  public readonly loginPanelColor: string = "#333333";
  public readonly loginPanelText = undefined;
  public readonly signInLogo = "assets/img/tractor_duo.png";
  public readonly brandLogo = "assets/img/blank.png";
  public readonly logoSize = "180px";
  public readonly background = "assets/img/bg_dark_1.png";
  public readonly loginWelcome =
    "<h4>Welcome to Flocheck</h4><br>Your one stop agri <br>management tool";
  public readonly bannerTitle = "Flocheck Dashboard";
  public readonly bannerLogo = "assets/img/in4mer_white.png";
  public readonly footerCopyRight = "©2021 In4m";
  public readonly bannerTopText = null;
  public readonly privacy = "";
  public readonly terms = "";
  public readonly documents = "";
  public readonly feedback = "";
  public readonly downloadPrefix = "flocheck";
  public readonly homeUrl = "https://www.in4mgroup.com/flavours/flocheck/";
  public readonly flavourType = "utilities";

  public readonly extendedDeviceSettingsMandatory = false;
  public readonly enableTFA = false;
  public readonly showLoginanimation = false;

  // Layout
  public readonly iframeLinks = [
    "https://www.in4mgroup.com/frames/flowcheck/?$itoken&$flavour&$ctoken&$role&$entity",
  ];
  public readonly showDevTab: boolean = false;
  public readonly devTabAvailable: boolean = false;
  public readonly showIncidentTab: boolean = false;
  public readonly showMapTab: boolean = true;
  public readonly allowChangeAccount: boolean = false;
  public readonly showManageAccounts: boolean = true;
  public readonly showAdmin = false;
  public readonly userManual = null;
  public readonly support = null;
  public readonly addLicencing = true;
  public readonly addLogoOnNewAccount = false;
  public readonly linkedin = null;
  public readonly twitter = null;
  public readonly youtube = null;
  public readonly instagram = null;
  public readonly facebook = null;
  public readonly showFAQs = false;
  public readonly showAppSelector = true;
  public readonly showVerifyUsers = false;
  public readonly showDeviceQuickView = false;
  public readonly flavourOptions = [];

  public readonly bucketDetails = {
    type: "service_account",
    project_id: "ravenhaven-accitrack",
    private_key_id: "980b69e1f720bc1427ee2e4cfb0d64df8311959b",
    private_key:
      "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDJuu3gF8/YMQO1\ng381KdeoFQxYJVyR03+GHdspoD/xKEyfLOdH0rUYQYr2/TwyrdlsE37AlC5hdEu2\nByVpBY+nQ3wjmjdFWj1m1XuqCGgrZHgc7R9oUfJCUJXupflt00OXwfJMrM5oMKJK\nMOXXbrZ7IUmulK6Lx6mWNjlU8tMWrfA4NvzN+l02hKlYAM0+esbcqkg+nrlPibNK\nSg7aLvpV3vvJ+OJLXTgyiNk1hZchhTQuj7I6RijJuvaw/Pyi3LE05cjvkseHgyue\n8Li0kBVG7x9sOTqh5CwIhp+zMovPzUvWgz+HqYSceFefMsgSL969EmluHnDAD4t+\nRjzQo30LAgMBAAECggEADIbAfaFM5TJJ9iv3qq/x9bx020ZapK165jOVZ9TNE6b6\ndwndRK73Us3DGMopwkXcUeM2BDRPWvrTNrbj4k0Xmf3NSBKr6vELDgckmi7SdRtU\ngAtTX3FzNx306XBB+EldkZ9X8d3rJTob4bp+ky2LREMRZbdSzVg1FiBA2B8J74b6\nQEk0fJnrhlGbCAAhAkMcG9jKlncWioBHbRofUm+KhHLDBv1IqJR5klDSitLqr3ym\nDPVbDMSZcngybeoY+10LEZK7DNyxGO3jK4ZiW2HfJC8f9JcKGKGp6X/Ej6thOPU3\nlF1Tc53tu2QGcYt+xiH/c2cHbNFzYYuZJ9QXUWfH1QKBgQDoh9AdJdx5/R462Vn0\nZXy+ZdpFFsy72ivKHCs0CjoLhfDSqubZFA/KkDQb0u4CgM2MCAVuK5qjGusdAlW/\nVRcPNunwUbsejJoSeeN9/cveBp5AZ550Sx31BZuikMDNFXa6DIsZoebtHF9nBqEr\nPSQ3Z66fT4Nhe3toHnN5UfGvrwKBgQDeF0n7cTx74mxKmYDBnD+HARahKWnQ0gI6\nfrOKSaixSjQ1h5owWk1C7vVZqxhRs2lFuc+u5aUvv2D7rSxbcE5tpWxhBkjE91Nn\noHC5ZE/+YTsgxhNK97SZItT3snEvh8PGDzxh2fj8AXMQhFEMzHEN8O25VT+MhBWm\nqnJpkc/jZQKBgC3dtCg7spyBV/glrT+u0QdBUed00tdu9lo8ai0uozpophL30Oca\ntO6wuQaP+ZCW1XR8lI2hnjPz+FJVhpJh91Vx8H0NsgoZk753Om88o3zc81Qi3Dd2\nJaeR/pv3T4BkbnHOTZW1wLYedZb90MaVndIr6l7UMUcGM1ZbQ0234yNTAoGAF9Y0\nEJK0xS8mJFOZaC5W+yx4u09wlgMUTibvKjaBrpWiSOSG/g2TIU34c2lTsOEquVsa\nGVF4i0llJV4O1rmVEVuh6D/+a3WINCUaNCu6EjlpWTkpNPClJ5J/fR5f25QcxRM5\njd8RRCr7qJgrAs6mi7KCMVQe//vlPwAoS4Bk6akCgYBRtG859zgdLlCFOOfQtkLc\nsfZBa8hDxcT5kYBcjIubMa1qT9Og520+q9J/zE5vG+aqStDz6SIwtoUemsohopOx\ntIzZgzZVZMXQhGv1fA4oyfLVbjhgSR8LrJBDE/cHu6DjD6wXP5E7Q2/6sT+5Mnwm\nArABA3/IzJgLb9+/eRzGyQ==\n-----END PRIVATE KEY-----\n",
    client_email: "ravenhaven-accitrack@appspot.gserviceaccount.com",
    client_id: "111620285050654134730",
    auth_uri: "https://accounts.google.com/o/oauth2/auth",
    token_uri: "https://oauth2.googleapis.com/token",
    auth_provider_x509_cert_url: "https://www.googleapis.com/oauth2/v1/certs",
    client_x509_cert_url:
      "https://www.googleapis.com/robot/v1/metadata/x509/ravenhaven-accitrack%40appspot.gserviceaccount.com",
  };

  //IoT setup
  //Define rules
  public readonly classTypes = [
    {
      name: "Site",
      rules: [],
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site Area",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Site ID",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Billing Period",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Report Email",
        },
        {
          value: false,
          type: "string",
          meta: null,
          key: "VAT",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (KL)",
        },
        {
          value: "false",
          type: "string",
          meta: null,
          key: "Fixed Levies",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 1 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 2 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 3 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 4 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 5 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 6 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 7 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 8 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 9 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step Rate 10 (ZAR/kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 1 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 2 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 3 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 4 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 5 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 6 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 7 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 8 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Step 9 (kWh)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 1 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 2 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 3 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 4 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 5 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 6 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 7 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 8 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step 9 (KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 1 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 2 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 3 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 4 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 5 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 6 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 7 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 8 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 9 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sew Step Rate 10 (ZAR/KL)",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Sewerage Percentage",
        },
        {
          value: "true",
          type: "boolean",
          meta: null,
          key: "Is Site",
        },
      ],
    },
  ];
  public readonly models = [
    {
      name: "Flocheck Pump Meter",
      code: "agr.flo",
      specifics: [
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Number",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Address Line 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Phone",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Client Email",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Installer Name",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Install Date",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Opening Reading",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Meter Model",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Daily Usage Limit",
        },
        {
          value: 2,
          type: "number",
          meta: null,
          key: "Tick Factor",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 1",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 2",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Photo 3",
        },
        {
          value: "",
          type: "string",
          meta: null,
          key: "Recipients",
        },
      ],
    },
  ];
  public readonly device_prefix = "flo";
}

//#endregion

export var buildSettings = new ProdSettingsThermologix();
